import React, { useMemo, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { KpiCard } from "../../../Component/RetailerMainComponents/KpiCard";
import { SectionCard } from "../../../Component/RetailerMainComponents/SectionCard";
import { Badge } from "../../../Component/RetailerMainComponents/Badge";
import Pagination from "../../../Component/Common/Pagination";
import RefreshButton from "../../../Component/Common/RefreshButton";

import {
  FileSpreadsheet,
  FileBarChart2,
  FileText,
  Wallet,
  Search,
  Eye,
  X,
  Filter,
  ChevronDown,
  Building2,
  CalendarDays,
  Hash,
  ArrowLeft,
} from "lucide-react";
import { BASE_URL } from "../../../config/api";
import RegularLoader from "../../../Component/Loader/RegularLoader";
import { formatDateTime } from "../../../Component/Common/formatDateTime";
import ExpandableCard from "../../../Component/Common/ExpandableCard";
import SimpleTable from "../../../Component/Common/SimpleTable";
import SearchInput from "../../../Component/Common/SearchInput";
import DateRangePicker from "../../../Component/Common/DateRangePicker";
import InvoiceMobileCard from "./InvoiceMobileCard";
import toast from "react-hot-toast";
import InvoicePage from "./Invoice/InvoicePage";
import { cn } from "./Invoice/invoiceUtils";

const TABS = [
  { key: "invoiced", label: "Invoiced" },
  { key: "uninvoiced", label: "Uninvoiced" },
  { key: "creditNotes", label: "Credit Notes" },
];

function money(n) {
  if (n === null || n === undefined) return "—";
  return `₹${Number(n).toLocaleString()}`;
}

function classNames(...x) {
  return x.filter(Boolean).join(" ");
}

/** ✅ Only badge colors (no row coloring) */
function statusBadgeVariant(status) {
  if (status === "Paid") return "success";
  if (status === "Partially Paid") return "warning";
  if (status === "Sent") return "info";
  return "danger"; // Unpaid
}

function parseDate(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  return Number.isNaN(d.getTime()) ? null : d;
}

function isBetween(dateStr, from, to) {
  const d = parseDate(dateStr);
  if (!d) return true;
  const start = from ? parseDate(from) : null;
  const end = to ? parseDate(to) : null;

  if (start && d < start) return false;
  if (end) {
    const endDay = new Date(end);
    endDay.setHours(23, 59, 59, 999);
    if (d > endDay) return false;
  }
  return true;
}

function Modal({ open, title, onClose, children }) {
  if (!open) return null;

  const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");

  const isRetailerMobile =
    typeof window !== "undefined" &&
    window.innerWidth < 640 &&
    Number(authUser?.role) === 5;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">

      {/* Overlay */}
      <div
        className={`absolute inset-0 ${
          isRetailerMobile ? "" : "bg-slate-900/40"
        }`}
        onClick={onClose}
      />

      {/* Modal */}
      <div
        className={`
          relative w-full max-w-3xl rounded-2xl shadow-xl
          ${
            isRetailerMobile
              ? "bg-white/10 backdrop-blur-2xl border border-white/30 text-black"
              : "border border-blue-100 bg-white"
          }
        `}
      >

        {/* Header */}
        <div
          className={`
            flex items-center justify-between gap-3 p-4 border-b
            ${
              isRetailerMobile
                ? "border-white/20"
                : "border-blue-100"
            }
          `}
        >
          <p
            className={`text-base font-semibold ${
              isRetailerMobile ? "text-black" : "text-slate-900"
            }`}
          >
            {title}
          </p>

          <button
            type="button"
            onClick={onClose}
            className={`
              inline-flex items-center justify-center rounded-xl p-2 transition
              ${
                isRetailerMobile
                  ? "bg-white/10 backdrop-blur border border-white/30 text-black hover:bg-white/20"
                  : "border border-blue-100 bg-blue-50 text-blue-700 hover:bg-blue-100"
              }
            `}
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        {/* Content */}
        <div
          className={`p-4 max-h-[80vh] overflow-y-auto ${
            isRetailerMobile ? "text-black" : ""
          }`}
        >
          {children}
        </div>

      </div>
    </div>
  );
}

// function TableToolbar({
//   tab,
//   search,
//   setSearch,
//   statusFilter,
//   setStatusFilter,
//   fromDate,
//   setFromDate,
//   toDate,
//   setToDate,
//   pageSize,
//   setPageSize,
//   onReset,
//   onRefresh,
// }) {
//   return (
//     <div className="mb-4 space-y-3">
//       {/* ROW 1: Search + Date */}
//       <div className="flex flex-col gap-3 md:flex-row md:items-center">
//         <div className="w-full md:w-[260px]">
//           <SearchInput
//             value={search}
//             onChange={setSearch}
//             onClear={() => setSearch("")}
//             placeholder="Search invoice / customer / phone"
//             size="md"
//           />
//         </div>

        
//       </div>

//       {/* ROW 2: Filters + Actions */}
//       <div className="flex flex-row gap-3 md:flex-row md:items-center ">
//         <div className="w-full md:w-[260px]">
//           <DateRangePicker
//             startDate={fromDate ? new Date(fromDate) : null}
//             endDate={toDate ? new Date(toDate) : null}
//             onChange={(start, end) => {
//               setFromDate(start ? start.toISOString().slice(0, 10) : "");
//               setToDate(end ? end.toISOString().slice(0, 10) : "");
//             }}
//           />
//         </div>

//         {/* LEFT: Status + Page size */}
//         <div className="flex flex-wrap gap-2">
//           {tab === "invoiced" && (
//             <select
//               value={statusFilter}
//               onChange={(e) => setStatusFilter(e.target.value)}
//               className="h-9 rounded-xl border border-blue-100 bg-white px-2 text-xs font-semibold"
//             >
//               <option value="all">All</option>
//               <option value="Paid">Paid</option>
//               <option value="Partially Paid">Partial</option>
//               <option value="Unpaid">Unpaid</option>
//               <option value="due">Due</option>
//             </select>
//           )}

//           <select
//             value={pageSize}
//             onChange={(e) => setPageSize(Number(e.target.value))}
//             className="h-9 rounded-xl border border-blue-100 bg-white px-2 text-xs font-semibold"
//           >
//             <option value={5}>5</option>
//             <option value={10}>10</option>
//             <option value={20}>20</option>
//             <option value={50}>50</option>
//           </select>
//         </div>

//         {/* RIGHT: Reset + Refresh */}
//         <div className="flex gap-2 md:justify-end">
//           <button
//             type="button"
//             onClick={onReset}
//             className="h-9 rounded-xl border border-blue-200 bg-white px-3 text-xs font-semibold text-blue-700"
//           >
//             Reset
//           </button>

//           <RefreshButton onClick={onRefresh} />
//         </div>
//       </div>
//     </div>
//   );
// }



// function TableToolbar({
//   tab,
//   search,
//   setSearch,
//   statusFilter,
//   setStatusFilter,
//   fromDate,
//   setFromDate,
//   toDate,
//   setToDate,
//   pageSize,
//   setPageSize,
//   onReset,
//   onRefresh,
// }) {
//   return (
//     <div className="mb-4 space-y-3">
//       {/* ================= DESKTOP + MOBILE WRAPPER ================= */}
//       <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-end">

//         {/* SEARCH */}
//         <div className="w-full md:w-[240px]">
//           <SearchInput
//             value={search}
//             onChange={setSearch}
//             onClear={() => setSearch("")}
//             placeholder="Search invoice / customer / phone"
//             size="md"
//           />
//         </div>

//         {/* DATE PICKER */}
//         <div className="w-full md:w-[160px]">
//           <DateRangePicker
//             startDate={fromDate ? new Date(fromDate) : null}
//             endDate={toDate ? new Date(toDate) : null}
//             onChange={(start, end) => {
//               setFromDate(start ? start.toISOString().slice(0, 10) : "");
//               setToDate(end ? end.toISOString().slice(0, 10) : "");
//             }}
//           />
//         </div>

//         {/* STATUS FILTER */}
//         {tab === "invoiced" && (
//           <select
//             value={statusFilter}
//             onChange={(e) => setStatusFilter(e.target.value)}
//             className="h-9 w-16 rounded-xl border border-blue-100 bg-white px-2 text-xs font-semibold"
//           >
//             <option value="all">All</option>
//             <option value="Paid">Paid</option>
//             <option value="Partially Paid">Partial</option>
//             <option value="Unpaid">Unpaid</option>
//             <option value="due">Due</option>
//           </select>
//         )}

//         {/* ROWS PER PAGE */}
//         <select
//           value={pageSize}
//           onChange={(e) => setPageSize(Number(e.target.value))}
//           className="h-9 w-24 rounded-xl border border-blue-100 bg-white px-2 text-xs font-semibold"
//         >
//           <option value={5}>5 / page</option>
//           <option value={10}>10 / page</option>
//           <option value={20}>20 / page</option>
//           <option value={50}>50 / page</option>
//         </select>

//         {/* ACTIONS */}
//         <div className="flex gap-2 justify-end md:justify-start">
//           <button
//             type="button"
//             onClick={onReset}
//             className="h-9 rounded-xl border border-blue-200 bg-white px-3 text-xs font-semibold text-blue-700"
//           >
//             Reset
//           </button>

//           <RefreshButton onClick={onRefresh} />
//         </div>
//       </div>
//     </div>
//   );
// }

function TableToolbar({
  tab,
  search,
  setSearch,
  statusFilter,
  setStatusFilter,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  pageSize,
  setPageSize,
  onReset,
  onRefresh,
}) {

  const authUserString = localStorage.getItem("authUserData");
  const authUser = authUserString ? JSON.parse(authUserString) : null;

    
  // Logged-in role (sidebar)
  const sessionRole = Number(authUser?.role);
  const sessionId = authUser?.id;
  const isRetailerMobile =
    window.innerWidth < 640 && sessionRole === 5;
  return (
  <div className="space-y-4 rounded-2xl p-2 mb-4">
    {/* <div
       className={cn(
         "space-y-4 rounded-2xl p-4 transition-all duration-300 md:hidden",
         isRetailerMobile
           ? "bg-white/10 backdrop-blur-2xl border border-white/30 shadow-[0_20px_50px_rgba(31,38,135,0.25)]"
           : ""
       )}
     > */}

      <SearchInput
        value={search}
        onChange={setSearch}
        onClear={() => setSearch("")}
        placeholder="Search invoice / customer / phone"
        size="md"
        className={cn(
          isRetailerMobile
            ? "bg-white/10 backdrop-blur-xl border border-white/30 shadow-[0_10px_25px_rgba(31,38,135,0.15)]"
            : ""
        )}
      />

      {/* DATE + PAGE SIZE */}
      <div className="flex gap-2">

        <div className="flex-1">
          <DateRangePicker
            startDate={fromDate ? new Date(fromDate) : null}
            endDate={toDate ? new Date(toDate) : null}
            onChange={(start, end) => {
              setFromDate(start ? start.toISOString().slice(0, 10) : "");
              setToDate(end ? end.toISOString().slice(0, 10) : "");
            }}
            isRetailerMobile={isRetailerMobile}
          />
        </div>

        <select
          value={pageSize}
          onChange={(e) => setPageSize(Number(e.target.value))}
          className={cn(
            "h-9 w-20 rounded-xl text-xs font-semibold outline-none transition-all duration-300",
            isRetailerMobile
              ? "bg-white/10 backdrop-blur-xl border border-white/30 text-slate-800 shadow-[0_10px_25px_rgba(31,38,135,0.15)]"
              : "border border-blue-100 bg-white"
          )}
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
        </select>
      </div>

      {/* ACTIONS */}
      <div className="flex justify-end gap-2">

        <button
          type="button"
          onClick={onReset}
          className={cn(
            "h-9 rounded-xl px-3 text-xs font-semibold transition-all duration-300",
            isRetailerMobile
              ? "bg-white/10 backdrop-blur-xl border border-white/30 text-slate-800 shadow-[0_10px_25px_rgba(31,38,135,0.15)] hover:bg-white/20"
              : "border border-blue-200 bg-white text-blue-700"
          )}
        >
          Reset
        </button>

        <RefreshButton onClick={onRefresh} />
      </div>
    </div>


   

  // {/* </div> */}
);
}



export default function InvoicesView({
  fromUserView = false,
  selectedUserId = null,
  selectedUserRole = null,
}) {

  const location = useLocation();
  // const forwardedState = location.state || {};

  // const fromUserView = forwardedState.fromUserView === true;
  // const selectedUserId = forwardedState.selectedUserId || null;
  // const selectedUserRole = forwardedState.selectedUserRole || null;
  // console.log("selected user role: ", selectedUserRole);

  // console.log("id from state: ", selectedUserId);


  const [invoices, setInvoices] = useState([]);
  const [uninvoiced, setUninvoiced] = useState([]);
  const [loading, setLoading] = useState(false);

  const [payoutSummary, setPayoutSummary] = useState({
  total_sales_invoiced: 0,
  total_sales_uninvoiced: 0,
  credit_notes: 0,
  paid_amount: 0,
  payable_amount: 0,
  pending_invoices: { count: 0, amount: 0 },
});


  const getRoleBasedParams = () => {
    const targetId = fromUserView ? selectedUserId : sessionId;
    const role = effectiveRole;

    if (!targetId || !role) {
      console.warn("❌ Missing role or targetId", { role, targetId });
      return {};
    }

    if (role === 2) return { company_id: targetId };
    if (role === 4) return { agent_id: targetId };
    if (role === 5) return { retailer_id: targetId };

    console.warn("❌ Unsupported role:", role);
    return {};
  };



  const resetFilters = () => {
    setSearch("");
    setCustomerCode("");
    setStatusFilter("all");
    setFromDate("");
    setToDate("");
    setCurrentPage(1);
  };

  // ✅ company name shown on all pages/tabs
  const companyObj = location.state?.c || location.state?.company || null;
  const companyName =
    companyObj?.business_name ||
    companyObj?.name ||
    location.state?.companyName ||
    "Company";

  const showOnlyDue = location.state?.showOnlyDue || false;
  const showOnlyPaid = location.state?.showOnlyPaid || false;

  // Tabs
  // const [tab, setTab] = useState("invoiced");
  // const location = useLocation();
  const defaultTab = location.state?.defaultTab || "invoiced";
  const [tab, setTab] = useState(defaultTab);

  // Toolbar
  const [search, setSearch] = useState("");
  const [customerCode, setCustomerCode] = useState("");
  const [statusFilter, setStatusFilter] = useState(showOnlyPaid ? "Paid" : showOnlyDue ? "due" : "all");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  // Modals
  const [openUninvoiced, setOpenUninvoiced] = useState(false);
  const [selectedUninvoiced, setSelectedUninvoiced] = useState(null);

  const [openInvoice, setOpenInvoice] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [debouncedSearch, setDebouncedSearch] = useState(search);

  const [paymentKeys, setPaymentKeys] = useState({
        key_id: "",
        key_secret: ""
      });

  const [keyLoading, setKeyLoading] = useState(false);
  const [paymentSaving, setPaymentSaving] = useState(false);

  const authUserString = localStorage.getItem("authUserData");
  const authUser = authUserString ? JSON.parse(authUserString) : null;

    
  // Logged-in role (sidebar)
  const sessionRole = Number(authUser?.role);
  const sessionId = authUser?.id;
  const isRetailerMobile =
    window.innerWidth < 640 && sessionRole === 5;

  // 🔥 Final role decision
  const effectiveRole = fromUserView
    ? Number(selectedUserRole)
    : sessionRole;

  const targetId = fromUserView ? selectedUserId : sessionId;


  useEffect(() => {
  const t = setTimeout(() => {
    setDebouncedSearch(search);
  }, 500); // ⏳ 500ms debounce

  return () => clearTimeout(t);
}, [search]);

      
  const fetchInvoices = async () => {
  try {
    setLoading(true);

    let endpoint = "warranty/get-devices";
    const query = new URLSearchParams();

    // ---- TAB → QUERY PARAMS ----
    if (tab === "invoiced") {
      query.append("invoice_status", "invoiced");
    } else if (tab === "uninvoiced") {
      query.append("invoice_status", "uninvoiced");
    } else if (tab === "creditNotes") {
      query.append("credit_note", "credit_note");
    }

    // ---- ROLE BASED PARAM ----
    const roleParams = getRoleBasedParams();
    Object.entries(roleParams).forEach(([k, v]) => query.append(k, v));

    // ---- SEARCH ----
    if (debouncedSearch) {
      query.append("search", debouncedSearch);
    }

    // ---- DATE FILTER ----
    if (fromDate) query.append("from_invoice_date", fromDate);
    if (toDate) query.append("to_invoice_date", toDate);

    const res = await fetch(`${BASE_URL}${endpoint}?${query.toString()}`);
    const json = await res.json();

    const rows =
  (json?.data || []).map((d) => {
    // ✅ SAFE PARSE invoice_json
    let invoiceMeta = null;
    try {
      invoiceMeta = d.invoice_json ? JSON.parse(d.invoice_json) : null;
    } catch (e) {
      invoiceMeta = null;
    }

    return {
      // ========= COMMON =========
      rawid:d.id,
      id:
        tab === "invoiced"
          ? d.invoice_id
          : tab === "creditNotes"
          ? d.id
          : `UNINV-${d.id}`,

      customerName: d.customer?.name || d.name,
      customerCode: d.customer?.c_code || "—",
      phone: d.customer?.mobile,

      amount: Number(d.product_price || 0),
      creditNote: Number(d.credit_note || 0),

      // ========= INVOICE META =========
      invoice_Code: invoiceMeta?.invoice_number || null,
      invoiceUrl: invoiceMeta?.invoice_url || null,
      invoiceBalance: Number(invoiceMeta?.balance ?? null),
      invoiceStatus: d.invoice_status,

      // ========= STATUS =========
      status: getInvoiceStatusLabel(d.invoice_status),
      paidAmount:
        tab === "invoiced" && invoiceMeta
          ? Number(d.product_price || 0) - Number(invoiceMeta.balance || 0)
          : 0,

      date: d.invoice_created_date || d.cd_issued_date || d.created_at,
      creditdate:d.cd_issued_date,
      dueDate: d.expiry_date,

      // ========= UNINVOICED =========
      warrantyId: d.w_code,
      IMEI1: d.imei1,
      IMEI2: d.imei2,
      serial: d.serial,
      model_id: d.model_id,
      product_id: d.product_id,
      w_customer_id: d.w_customer_id,
      warrantyType: d.product_name,
      billPhoto: d.billPhoto,
      link1: d.link1,
      deviceInfo: `${d.brand_name} • ${d.model}`,
      purchaseDate: d.created_at,

      // ========= CREDIT NOTE =========
      creditId: d.credit_note ? d.id : null,
      reason: d.note || "Credit Adjustment",
    };
  }) || [];


    if (tab === "invoiced") setInvoices(rows);
    if (tab === "uninvoiced") setUninvoiced(rows);
    if (tab === "creditNotes") setInvoices(rows); // reuse invoices state

  } catch (err) {
    console.error("❌ Device fetch failed", err);
  } finally {
    setLoading(false);
  };


    console.log("🧭 Invoice Context", {
      fromUserView,
      sessionRole,
      selectedUserRole,
      effectiveRole,
      sessionId,
      selectedUserId,
      roleParams: getRoleBasedParams(),
    });
  };
   useEffect(() => {
  // Clear immediately on tab change
  setInvoices([]);
  setUninvoiced([]);
  setCurrentPage(1);
}, [tab]);

useEffect(() => {
  fetchInvoices();
}, [tab, debouncedSearch, fromDate, toDate, sessionId, selectedUserId, effectiveRole]);


function getInvoiceStatusLabel(status) {
  if (!status) return "Unpaid";

  if (status === "paid") return "Paid";
  if (status === "sent") return "Sent";
  if (status === "partially_paid") return "Partially Paid";

  return "Unpaid";
}


function isPdf(url) {
  return typeof url === "string" && url.toLowerCase().endsWith(".pdf");
}

function getEmptyMessage(tab) {
  if (tab === "invoiced") return "No invoices found";
  if (tab === "uninvoiced") return "No pending invoices found";
  if (tab === "creditNotes") return "No credit notes found";
  return "No data found";
}

const fetchPayoutSummary = async () => {
  try {
    const params = new URLSearchParams();
    const targetId = fromUserView ? selectedUserId : sessionId;

    if (!targetId || !effectiveRole) return;

    if (effectiveRole === 2) params.append("company_id", targetId);
    if (effectiveRole === 4) params.append("agent_id", targetId);
    if (effectiveRole === 5) params.append("retailer_id", targetId);

    const res = await fetch(
      `${BASE_URL}warranty/payout-summary?${params.toString()}`
    );
    const json = await res.json();

    if (!json?.status) return;

    setPayoutSummary({
      total_sales_invoiced: Number(json.data?.total_sales_invoiced || 0),
      total_sales_uninvoiced: Number(json.data?.total_sales_uninvoiced || 0),
      credit_notes: Number(json.data?.credit_notes || 0),
      paid_amount: Number(json.data?.paid_amount || 0),
      payable_amount: Number(json.data?.payable_amount || 0),
      pending_invoices: {
        count: Number(json.data?.pending_invoices?.count || 0),
        amount: Number(json.data?.pending_invoices?.amount || 0),
      },
    });
  } catch (err) {
    console.error("❌ Payout summary fetch failed", err);
  }
};

useEffect(() => {
  fetchPayoutSummary();
}, [effectiveRole, sessionId, selectedUserId, fromUserView]);

  const creditNotes = useMemo(() => {
    return invoices
      .filter((x) => x.creditNote > 0)
      .map((x) => ({
        creditId: x.id,
        invoiceId: x.invoice_Code,
        date: x.creditdate,
        amount: x.amount,
        customerName: x.customerName,
        customerCode: x.customerCode,
        // reason: "Adjustment / Discount",
      }));
  }, [invoices]);

  // KPIs
  const totals = useMemo(() => {
    const totalInvoiceAmount = invoices.reduce((sum, inv) => sum + inv.amount, 0);
    const totalCreditNotes = invoices.reduce((sum, inv) => sum + inv.creditNote, 0);
    return { totalInvoiceAmount, totalCreditNotes };
  }, [invoices]);

  const moneyStats = useMemo(() => ({ payableAmount: 120000, paidAmount: 90000 }), []);

  useEffect(() => {
    setCurrentPage(1);
  }, [tab, search, statusFilter, pageSize, customerCode, fromDate, toDate]);

  // Filtering
  const filteredRows = useMemo(() => {
    const q = search.trim().toLowerCase();
    const cc = customerCode.trim().toLowerCase();

    if (tab === "invoiced") {
      let rows = [...invoices];

      if (showOnlyPaid) rows = rows.filter((r) => r.status === "paid");
      if (showOnlyDue) rows = rows.filter((r) => r.status === "Partially Paid" || r.status === "Unpaid");

      if (statusFilter === "due") {
        rows = rows.filter((r) => r.status === "Partially Paid" || r.status === "Unpaid");
      } else if (statusFilter !== "all") {
        rows = rows.filter((r) => r.status === statusFilter);
      }

      rows = rows.filter((r) => isBetween(r.date, fromDate, toDate));
      if (cc) rows = rows.filter((r) => String(r.customerCode || "").toLowerCase().includes(cc));
      return rows;
    }

    if (tab === "uninvoiced") {
      let rows = [...uninvoiced];
      rows = rows.filter((r) => isBetween(r.purchaseDate, fromDate, toDate));
      if (cc) rows = rows.filter((r) => String(r.customerCode || "").toLowerCase().includes(cc));

      if (q) {
        rows = rows.filter((r) =>
          [r.id, r.customerName, r.customerCode, r.phone, r.warrantyId, r.warrantyType, r.deviceInfo, r.purchaseDate]
            .filter(Boolean)
            .join(" ")
            .toLowerCase()
            .includes(q)
        );
      }
      return rows;
    }

    // creditNotes
    let rows = [...creditNotes];
    rows = rows.filter((r) => isBetween(r.date, fromDate, toDate));
    if (cc) rows = rows.filter((r) => String(r.customerCode || "").toLowerCase().includes(cc));
    if (q) {
      rows = rows.filter((r) =>
        [r.creditId, r.invoiceId, r.customerName, r.customerCode, r.reason, r.date]
          .filter(Boolean)
          .join(" ")
          .toLowerCase()
          .includes(q)
      );
    }
    return rows;
  }, [tab, invoices, uninvoiced, creditNotes, search, statusFilter, showOnlyPaid, showOnlyDue, customerCode, fromDate, toDate]);

  // Pagination
  const totalPages = Math.max(1, Math.ceil(filteredRows.length / pageSize));
  const pageRows = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return filteredRows.slice(start, start + pageSize);
  }, [filteredRows, currentPage, pageSize]);

  // Actions
  const onViewInvoice = (row) => {
    setSelectedInvoice(row);
    setOpenInvoice(true);
  };

  const onViewUninvoiced = (row) => {
    setSelectedUninvoiced(row);
    setOpenUninvoiced(true);
  };

  const tabTitle =
    tab === "invoiced" ? "Invoice List" : tab === "uninvoiced" ? "Uninvoiced" : "Credit Notes";

  
  const fetchPaymentKeys = async () => {
    try {
      setKeyLoading(true);
  
      const res = await fetch(`${BASE_URL}payment/keys`);
      const data = await res.json();
  
      if (Array.isArray(data) && data.length > 0) {
        setPaymentKeys({
          key_id: data[0].key_id,
          key_secret: data[0].key_secret
        });
      } else {
        console.error("Invalid keys response", data);
      }
    } catch (err) {
      console.error("Failed to fetch payment keys", err);
    } finally {
      setKeyLoading(false);
    }
  };
  
    useEffect(() => {
      fetchPaymentKeys();
  }, []);

  const handlePayNow = async (row) => {
  if (!paymentKeys?.key_id) {
    toast.error("Payment keys not loaded");
    return;
  }

  // 💰 amount from invoice row
  const amount = Number(row.amount || 0);
  const roundedAmount = Math.round(amount * 100); // paise

  // 🧾 Notes built from ROW
  const notes = {
    project: "warranty",
    service: "update",
    imei1: row.IMEI1,
    imei2: row.IMEI2,
    serial:row.serial,
    product_id:row.product_id,
    model_id:row.model_id,
    company_id: authUser?.company_id,
    retailer_id: sessionId,
    agent_id: authUser?.agent_id,
    amount: amount,
    // warranty_id: row.warrantyId || null,
    // invoice_id: row.id || null,
    w_customer_id:row.w_customer_id,
    created_by: sessionId,
    document_url: row.billPhoto,
    device_id: row.rawid,
  };

  const options = {
    key: paymentKeys.key_id,
    amount: roundedAmount,
    currency: "INR",
    name: "GO Electronix",
    description: `Invoice Payment - ${row.invoice_Code || row.id}`,
    notes,

    handler: async function (response) {
      try {
        setPaymentSaving(true);

        console.log("✅ Razorpay Success:", response);
        console.log("📦 Paid Row:", row);

        const payload = {
          payment_id: response.razorpay_payment_id,

          invoice_id: row.id,
          invoice_code: row.invoice_Code,

          amount,
          customer_name: row.customerName,
          customer_code: row.customerCode,

          retailer_id: sessionId,
          company_id: authUser?.company_id,

          source: "invoice_pay_now",
        };

        console.log("🚀 Payment Payload:", payload);

        toast.success("Payment successful 🎉");

        // 🔁 Refresh invoices after payment
        fetchInvoices();
        fetchPayoutSummary();
      } catch (err) {
        console.error(err);
        toast.error("Payment succeeded but processing failed");
      } finally {
        setPaymentSaving(false);
      }
    },

    prefill: {
      name: row.customerName || "",
      contact: row.phone || "",
    },

    theme: { color: "#2563eb" },
  };

  const rzp = new window.Razorpay(options);
  rzp.open();
};



  return (
    <div
      className={`space-y-4 transition-all duration-300 ${
        isRetailerMobile
          ? "px-3 pb-20"
          : ""
      }`}
      >
      {/* ✅ Company header always */}
      {/* <div className="rounded-2xl border border-blue-100 bg-white p-4 shadow-sm">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <div className="rounded-2xl bg-blue-50 p-3 text-blue-700">
              <Building2 className="h-5 w-5" />
            </div>
            <div>
              <p className="text-xs font-semibold text-slate-500">Company</p>
              <p className="text-base font-semibold text-slate-900">{companyName}</p>
            </div>
          </div>
          <div className="text-xs font-semibold text-slate-500">
            Records: <span className="font-semibold text-slate-900">{filteredRows.length}</span>
          </div>
        </div>
      </div> */}

      {/* KPI Cards */}
     <div
      className={`grid grid-cols-2 gap-3 md:grid-cols-4 transition-all duration-300 ${
        isRetailerMobile ? "px-1" : ""
      }`}
    >
        <KpiCard
          label="Invoice Amount"
          value={money(payoutSummary.total_sales_invoiced)}
          subLabel="Total invoiced"
          icon={FileSpreadsheet}
          isRetailerMobile={isRetailerMobile}
        />

        <KpiCard
          label="Uninvoiced"
          value={money(payoutSummary.total_sales_uninvoiced)}
          subLabel="Pending billing"
          icon={FileBarChart2}
          isRetailerMobile={isRetailerMobile}
        />

        <KpiCard
          label="Credit Notes"
          value={money(payoutSummary.credit_notes)}
          subLabel={`${payoutSummary.pending_invoices.count} pending invoices`}
          icon={FileText}
          isRetailerMobile={isRetailerMobile}
        />

        <KpiCard
          label="Paid Amount"
          value={money(payoutSummary.paid_amount)}
          subLabel={`Payable: ${money(payoutSummary.payable_amount)}`}
          icon={Wallet}
          isRetailerMobile={isRetailerMobile}
        />
      </div>


      {/* Tabs */}
      <div
        className={`flex gap-2 overflow-x-auto rounded-2xl p-2 transition-all duration-300 ${
          isRetailerMobile
            ? "bg-white/10 backdrop-blur-2xl border border-white/30 shadow-[0_15px_35px_rgba(31,38,135,0.25)]"
            : "border border-blue-100 bg-white"
        }`}
      >
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setTab(t.key)}
            className={classNames(
              "whitespace-nowrap rounded-xl px-4 py-2 text-sm font-semibold transition-all duration-300",
              isRetailerMobile
                ? tab === t.key
                  ? "bg-blue-600 text-white"
                  : "bg-white/10 text-black/80 border border-white/20 backdrop-blur-xl hover:bg-white/20 shadow-[0_8px_25px_rgba(255,255,255,0.25)]"
                : tab === t.key
                  ? "bg-blue-600 text-black"
                  : "bg-blue-50 text-blue-700 hover:bg-blue-100"
            )}
          >
            {t.label}
          </button>
        ))}
      </div>

      <SectionCard title={tabTitle} isRetailerMobile={isRetailerMobile}>
        {/* ================= INVOICED TAB ================= */}
        {tab === "invoiced" ? (
           <InvoicePage
              effectiveRole={effectiveRole}
              targetId={targetId}
            />
        ) : (
          <>
            {/* ================= EXISTING TOOLBAR ================= */}
            <div
              className={`rounded-2xl p-2 transition-all duration-300 ${
                isRetailerMobile
                  ? "bg-white/10 backdrop-blur-2xl border border-white/30 shadow-[0_20px_50px_rgba(31,38,135,0.25)]"
                  : "border border-blue-100 bg-white"
              }`}
            >
              <div className="flex-1">
                <TableToolbar
                  tab={tab}
                  search={search}
                  setSearch={setSearch}
                  customerCode={customerCode}
                  setCustomerCode={setCustomerCode}
                  statusFilter={statusFilter}
                  setStatusFilter={setStatusFilter}
                  fromDate={fromDate}
                  setFromDate={setFromDate}
                  toDate={toDate}
                  setToDate={setToDate}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  onReset={resetFilters}
                  onRefresh={fetchInvoices}
                />
              </div>
            </div>

            {/* ================= DESKTOP TABLE ================= */}
            <div className="hidden lg:block">
              {loading ? (
                <div className="flex justify-center items-center py-16">
                  <RegularLoader />
                </div>
              ) : filteredRows.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-20 text-center">
                  <FileText className="h-10 w-10 text-slate-300 mb-3" />
                  <p className="text-sm font-semibold text-slate-600">
                    {getEmptyMessage(tab)}
                  </p>
                </div>
              ) : (
                <SimpleTable
                  headers={
                    tab === "uninvoiced"
                      ? ["Ref", "Customer", "Customer Code", "Phone", "Warranty", "Purchase Date", "Amount", "Status"]
                      : ["Credit Note", "Invoice", "Customer", "Customer Code", "Amount", "Date",]
                  }
                  rows={pageRows.map((row) => {
                    if (tab === "uninvoiced") {
                      return {
                        raw: row,
                        cells: [
                          row.id,
                          row.customerName,
                          row.customerCode || "—",
                          row.phone,
                          { title: row.warrantyId, sub: row.warrantyType },
                          formatDateTime(row.purchaseDate),
                          money(row.amount),
                          <Badge variant={statusBadgeVariant(row.status)}>{row.status}</Badge>,
                        ],
                      };
                    }

                    return {
                      raw: row,
                      cells: [
                        row.creditId,
                        row.invoiceId,
                        row.customerName,
                        row.customerCode || "—",
                        money(row.amount),
                        formatDateTime(row.date),
                        // row.reason,
                      ],
                    };
                  })}
                  renderActions={(row) => (
                    <div className="flex items-center gap-2 justify-center">
                      <button
                        onClick={() =>
                          tab === "uninvoiced"
                            ? onViewUninvoiced(row)
                            : onViewInvoice(row)
                        }
                        className="inline-flex items-center gap-2 rounded-xl border border-blue-200 bg-blue-50 px-3 py-2 text-xs font-semibold text-blue-700 hover:bg-blue-100"
                      >
                        <Eye className="h-4 w-4" />
                        View
                      </button>
                    </div>
                  )}
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                  align="center"
                />
              )}
            </div>

            {/* ================= MOBILE CARDS ================= */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 lg:hidden">
              {loading ? (
                <div className="col-span-full flex justify-center py-16">
                  <RegularLoader />
                </div>
              ) : pageRows.length === 0 ? (
                <div className="col-span-full flex flex-col items-center justify-center py-20 text-center">
                  <FileText className="h-10 w-10 text-slate-300 mb-3" />
                  <p className="text-sm font-semibold text-slate-600">
                    {getEmptyMessage(tab)}
                  </p>
                </div>
              ) : (
                <>
                  {pageRows.map((row) => (
                    <InvoiceMobileCard
                      key={row.id || row.creditId}
                      row={row}
                      tab={tab}
                      onViewInvoice={onViewInvoice}
                      onViewUninvoiced={onViewUninvoiced}
                      money={money}
                      formatDateTime={formatDateTime}
                    />
                  ))}

                  {totalPages > 1 && (
                    <div className="col-span-full">
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          </>
        )}
      </SectionCard>


      {/* ✅ Uninvoiced Details Modal */}
      <Modal
  open={openUninvoiced}
  title="Uninvoiced Details"
  onClose={() => {
    setOpenUninvoiced(false);
    setSelectedUninvoiced(null);
  }}
>
  {selectedUninvoiced ? (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2">

      {[
        ["Customer Name", selectedUninvoiced.customerName],
        ["Customer Code", selectedUninvoiced.customerCode || "—"],
        ["Phone No", selectedUninvoiced.phone],
        ["Warranty ID", selectedUninvoiced.warrantyId],
        ["Type of Warranty", selectedUninvoiced.warrantyType],
        ["Purchase Date", selectedUninvoiced.purchaseDate],
        ["Amount", money(selectedUninvoiced.amount)],
      ].map(([k, v]) => (
        <div
          key={k}
          className={`
            rounded-xl p-3 border
            ${
              isRetailerMobile
                ? "bg-white/10 backdrop-blur-xl border-white/30 text-black"
                : "border-blue-100 bg-white"
            }
          `}
        >
          <p
            className={`text-xs font-semibold ${
              isRetailerMobile ? "text-black/70" : "text-slate-500"
            }`}
          >
            {k}
          </p>

          <p
            className={`text-sm font-semibold ${
              isRetailerMobile ? "text-black" : "text-slate-900"
            }`}
          >
            {v}
          </p>
        </div>
      ))}

      <div
        className={`
          rounded-xl p-3 border md:col-span-2
          ${
            isRetailerMobile
              ? "bg-white/10 backdrop-blur-xl border-white/30 text-black"
              : "border-blue-100 bg-white"
          }
        `}
      >
        <p
          className={`text-xs font-semibold ${
            isRetailerMobile ? "text-black/70" : "text-slate-500"
          }`}
        >
          Device Info
        </p>

        <p
          className={`text-sm font-semibold ${
            isRetailerMobile ? "text-black" : "text-slate-900"
          }`}
        >
          {selectedUninvoiced.deviceInfo}
        </p>
      </div>

      {/* ACTION */}
      <div className="mt-2 flex justify-end md:col-span-2">
        <button
          type="button"
          onClick={() => {
            setOpenUninvoiced(false);
            setSelectedUninvoiced(null);
          }}
          className={`
            inline-flex items-center gap-2 rounded-xl px-4 py-2 text-sm font-semibold transition
            ${
              isRetailerMobile
                ? "bg-white/10 backdrop-blur-xl border border-white/30 text-black hover:bg-white/20"
                : "border border-blue-200 bg-blue-50 text-blue-700 hover:bg-blue-100"
            }
          `}
        >
          <ArrowLeft className="h-4 w-4" />
          Previous
        </button>
      </div>

    </div>
  ) : null}
</Modal>

      {/* ✅ Invoice View Modal Layout + Previous button restored */}
      <Modal
        open={openInvoice}
        title="Invoice View"
        onClose={() => {
          setOpenInvoice(false);
          setSelectedInvoice(null);
        }}
      >
        {selectedInvoice ? (
          <div className="space-y-4">
            <div className="rounded-2xl border border-blue-100 bg-blue-50 p-4">
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div>
                  <p className="text-xs font-semibold text-slate-500">Invoice</p>
                  <p className="text-sm font-semibold text-slate-900">{selectedInvoice.id}</p>
                  {"customerName" in selectedInvoice ? (
                    <p className="mt-1 text-xs font-semibold text-slate-600">
                      Customer: <span className="font-semibold text-slate-900">{selectedInvoice.customerName}</span>
                      {"customerCode" in selectedInvoice && selectedInvoice.customerCode ? (
                        <>
                          {" "}
                          • Code: <span className="font-semibold text-slate-900">{selectedInvoice.customerCode}</span>
                        </>
                      ) : null}
                    </p>
                  ) : null}
                </div>

                {"status" in selectedInvoice ? (
                  <div className="flex items-center gap-2">
                    <Badge variant={statusBadgeVariant(selectedInvoice.status)}>{selectedInvoice.status}</Badge>
                  </div>
                ) : null}
              </div>

              <div className="mt-3 grid grid-cols-1 gap-3 md:grid-cols-3">
                {"amount" in selectedInvoice ? (
                  <div className="rounded-xl border border-blue-100 bg-white p-3">
                    <p className="text-xs font-semibold text-slate-500">Amount</p>
                    <p className="text-sm font-semibold text-slate-900">{money(selectedInvoice.amount)}</p>
                  </div>
                ) : null}

                {"paidAmount" in selectedInvoice ? (
                  <div className="rounded-xl border border-blue-100 bg-white p-3">
                    <p className="text-xs font-semibold text-slate-500">Paid</p>
                    <p className="text-sm font-semibold text-slate-900">{money(selectedInvoice.paidAmount)}</p>
                  </div>
                ) : null}

                {"creditNote" in selectedInvoice ? (
                  <div className="rounded-xl border border-blue-100 bg-white p-3">
                    <p className="text-xs font-semibold text-slate-500">Credit Note</p>
                    <p className="text-sm font-semibold text-slate-900">{money(selectedInvoice.creditNote)}</p>
                  </div>
                ) : null}
              </div>
            </div>

            {/* PDF / Preview area */}
            <div className="rounded-2xl border border-blue-100 bg-white p-4 space-y-3">
              <div className="flex items-center justify-between">
                <p className="text-sm font-semibold text-slate-900">Invoice Preview</p>

                {selectedInvoice?.invoiceUrl && (
                  <a
                    href={selectedInvoice.invoiceUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rounded-lg border border-blue-200 bg-blue-50 px-3 py-1 text-xs font-semibold text-blue-700 hover:bg-blue-100"
                  >
                    Open in new tab
                  </a>
                )}
              </div>

              {selectedInvoice?.invoiceUrl ? (
                <iframe
                  src={`${selectedInvoice.invoiceUrl}#toolbar=0&navpanes=0`}
                  title="Invoice PDF"
                  className="h-[60vh] md:h-[520px] w-full rounded-xl border border-blue-100"
                />
              ) : (
                <div className="rounded-xl border border-dashed border-slate-300 bg-slate-50 p-6 text-center text-sm font-semibold text-slate-500">
                  Invoice preview not available
                </div>
              )}
            </div>

            <div className="flex justify-end">
              <button
                type="button"
                onClick={() => {
                  setOpenInvoice(false);
                  setSelectedInvoice(null);
                }}
                className="inline-flex items-center gap-2 rounded-xl border border-blue-200 bg-blue-50 px-4 py-2 text-sm font-semibold text-blue-700 hover:bg-blue-100"
              >
                <ArrowLeft className="h-4 w-4" />
                Previous
              </button>
            </div>
          </div>
        ) : null}
      </Modal>
    </div>
  );
}




// import React, { useMemo, useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import { KpiCard } from "../../../Component/RetailerMainComponents/KpiCard";
// import { SectionCard } from "../../../Component/RetailerMainComponents/SectionCard";
// import { Badge } from "../../../Component/RetailerMainComponents/Badge";
// import Pagination from "../../../Component/Common/Pagination";
// import RefreshButton from "../../../Component/Common/RefreshButton";

// import {
//   FileSpreadsheet,
//   FileBarChart2,
//   FileText,
//   Wallet,
//   Search,
//   Eye,
//   X,
//   Filter,
//   ChevronDown,
//   Building2,
//   CalendarDays,
//   Hash,
//   ArrowLeft,
// } from "lucide-react";
// import { BASE_URL } from "../../../config/api";
// import RegularLoader from "../../../Component/Loader/RegularLoader";
// import { formatDateTime } from "../../../Component/Common/formatDateTime";
// import ExpandableCard from "../../../Component/Common/ExpandableCard";
// import SimpleTable from "../../../Component/Common/SimpleTable";
// import SearchInput from "../../../Component/Common/SearchInput";
// import DateRangePicker from "../../../Component/Common/DateRangePicker";
// import InvoiceMobileCard from "./InvoiceMobileCard";
// import toast from "react-hot-toast";

// const TABS = [
//   { key: "invoiced", label: "Invoiced" },
//   { key: "uninvoiced", label: "Uninvoiced" },
//   { key: "creditNotes", label: "Credit Notes" },
// ];

// function money(n) {
//   if (n === null || n === undefined) return "—";
//   return `₹${Number(n).toLocaleString()}`;
// }

// function classNames(...x) {
//   return x.filter(Boolean).join(" ");
// }

// /** ✅ Only badge colors (no row coloring) */
// function statusBadgeVariant(status) {
//   if (status === "Paid") return "success";
//   if (status === "Partially Paid") return "warning";
//   if (status === "Sent") return "info";
//   return "danger"; // Unpaid
// }

// function parseDate(dateStr) {
//   if (!dateStr) return null;
//   const d = new Date(dateStr);
//   return Number.isNaN(d.getTime()) ? null : d;
// }

// function isBetween(dateStr, from, to) {
//   const d = parseDate(dateStr);
//   if (!d) return true;
//   const start = from ? parseDate(from) : null;
//   const end = to ? parseDate(to) : null;

//   if (start && d < start) return false;
//   if (end) {
//     const endDay = new Date(end);
//     endDay.setHours(23, 59, 59, 999);
//     if (d > endDay) return false;
//   }
//   return true;
// }

// function Modal({ open, title, onClose, children }) {
//   if (!open) return null;
//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
//       <div className="absolute inset-0 bg-slate-900/40" onClick={onClose} />
//       <div className="relative w-full max-w-3xl rounded-2xl border border-blue-100 bg-white shadow-xl">
//         <div className="flex items-center justify-between gap-3 border-b border-blue-100 p-4">
//           <p className="text-base font-semibold text-slate-900">{title}</p>
//           <button
//             type="button"
//             onClick={onClose}
//             className="inline-flex items-center justify-center rounded-xl border border-blue-100 bg-blue-50 p-2 text-blue-700 hover:bg-blue-100"
//           >
//             <X className="h-4 w-4" />
//           </button>
//         </div>
//         <div className="p-4 max-h-[80vh] overflow-y-auto">
//           {children}
//         </div>
//       </div>
//     </div>
//   );
// }

// // function TableToolbar({
// //   tab,
// //   search,
// //   setSearch,
// //   statusFilter,
// //   setStatusFilter,
// //   fromDate,
// //   setFromDate,
// //   toDate,
// //   setToDate,
// //   pageSize,
// //   setPageSize,
// //   onReset,
// //   onRefresh,
// // }) {
// //   return (
// //     <div className="mb-4 space-y-3">
// //       {/* ROW 1: Search + Date */}
// //       <div className="flex flex-col gap-3 md:flex-row md:items-center">
// //         <div className="w-full md:w-[260px]">
// //           <SearchInput
// //             value={search}
// //             onChange={setSearch}
// //             onClear={() => setSearch("")}
// //             placeholder="Search invoice / customer / phone"
// //             size="md"
// //           />
// //         </div>

        
// //       </div>

// //       {/* ROW 2: Filters + Actions */}
// //       <div className="flex flex-row gap-3 md:flex-row md:items-center ">
// //         <div className="w-full md:w-[260px]">
// //           <DateRangePicker
// //             startDate={fromDate ? new Date(fromDate) : null}
// //             endDate={toDate ? new Date(toDate) : null}
// //             onChange={(start, end) => {
// //               setFromDate(start ? start.toISOString().slice(0, 10) : "");
// //               setToDate(end ? end.toISOString().slice(0, 10) : "");
// //             }}
// //           />
// //         </div>

// //         {/* LEFT: Status + Page size */}
// //         <div className="flex flex-wrap gap-2">
// //           {tab === "invoiced" && (
// //             <select
// //               value={statusFilter}
// //               onChange={(e) => setStatusFilter(e.target.value)}
// //               className="h-9 rounded-xl border border-blue-100 bg-white px-2 text-xs font-semibold"
// //             >
// //               <option value="all">All</option>
// //               <option value="Paid">Paid</option>
// //               <option value="Partially Paid">Partial</option>
// //               <option value="Unpaid">Unpaid</option>
// //               <option value="due">Due</option>
// //             </select>
// //           )}

// //           <select
// //             value={pageSize}
// //             onChange={(e) => setPageSize(Number(e.target.value))}
// //             className="h-9 rounded-xl border border-blue-100 bg-white px-2 text-xs font-semibold"
// //           >
// //             <option value={5}>5</option>
// //             <option value={10}>10</option>
// //             <option value={20}>20</option>
// //             <option value={50}>50</option>
// //           </select>
// //         </div>

// //         {/* RIGHT: Reset + Refresh */}
// //         <div className="flex gap-2 md:justify-end">
// //           <button
// //             type="button"
// //             onClick={onReset}
// //             className="h-9 rounded-xl border border-blue-200 bg-white px-3 text-xs font-semibold text-blue-700"
// //           >
// //             Reset
// //           </button>

// //           <RefreshButton onClick={onRefresh} />
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }



// // function TableToolbar({
// //   tab,
// //   search,
// //   setSearch,
// //   statusFilter,
// //   setStatusFilter,
// //   fromDate,
// //   setFromDate,
// //   toDate,
// //   setToDate,
// //   pageSize,
// //   setPageSize,
// //   onReset,
// //   onRefresh,
// // }) {
// //   return (
// //     <div className="mb-4 space-y-3">
// //       {/* ================= DESKTOP + MOBILE WRAPPER ================= */}
// //       <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-end">

// //         {/* SEARCH */}
// //         <div className="w-full md:w-[240px]">
// //           <SearchInput
// //             value={search}
// //             onChange={setSearch}
// //             onClear={() => setSearch("")}
// //             placeholder="Search invoice / customer / phone"
// //             size="md"
// //           />
// //         </div>

// //         {/* DATE PICKER */}
// //         <div className="w-full md:w-[160px]">
// //           <DateRangePicker
// //             startDate={fromDate ? new Date(fromDate) : null}
// //             endDate={toDate ? new Date(toDate) : null}
// //             onChange={(start, end) => {
// //               setFromDate(start ? start.toISOString().slice(0, 10) : "");
// //               setToDate(end ? end.toISOString().slice(0, 10) : "");
// //             }}
// //           />
// //         </div>

// //         {/* STATUS FILTER */}
// //         {tab === "invoiced" && (
// //           <select
// //             value={statusFilter}
// //             onChange={(e) => setStatusFilter(e.target.value)}
// //             className="h-9 w-16 rounded-xl border border-blue-100 bg-white px-2 text-xs font-semibold"
// //           >
// //             <option value="all">All</option>
// //             <option value="Paid">Paid</option>
// //             <option value="Partially Paid">Partial</option>
// //             <option value="Unpaid">Unpaid</option>
// //             <option value="due">Due</option>
// //           </select>
// //         )}

// //         {/* ROWS PER PAGE */}
// //         <select
// //           value={pageSize}
// //           onChange={(e) => setPageSize(Number(e.target.value))}
// //           className="h-9 w-24 rounded-xl border border-blue-100 bg-white px-2 text-xs font-semibold"
// //         >
// //           <option value={5}>5 / page</option>
// //           <option value={10}>10 / page</option>
// //           <option value={20}>20 / page</option>
// //           <option value={50}>50 / page</option>
// //         </select>

// //         {/* ACTIONS */}
// //         <div className="flex gap-2 justify-end md:justify-start">
// //           <button
// //             type="button"
// //             onClick={onReset}
// //             className="h-9 rounded-xl border border-blue-200 bg-white px-3 text-xs font-semibold text-blue-700"
// //           >
// //             Reset
// //           </button>

// //           <RefreshButton onClick={onRefresh} />
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// function TableToolbar({
//   tab,
//   search,
//   setSearch,
//   statusFilter,
//   setStatusFilter,
//   fromDate,
//   setFromDate,
//   toDate,
//   setToDate,
//   pageSize,
//   setPageSize,
//   onReset,
//   onRefresh,
// }) {
//   return (
//     <div className="mb-4 space-y-3">

//       {/* ================= MOBILE LAYOUT ================= */}
//       <div className="space-y-3 md:hidden">

//         {/* ROW 1: SEARCH */}
//         <SearchInput
//           value={search}
//           onChange={setSearch}
//           onClear={() => setSearch("")}
//           placeholder="Search invoice / customer / phone"
//           size="md"
//         />

//         {/* ROW 2: DATE | FILTER | PAGE SIZE */}
//         <div className="flex gap-2">
//           <div className="flex-1">
//             <DateRangePicker
//               startDate={fromDate ? new Date(fromDate) : null}
//               endDate={toDate ? new Date(toDate) : null}
//               onChange={(start, end) => {
//                 setFromDate(start ? start.toISOString().slice(0, 10) : "");
//                 setToDate(end ? end.toISOString().slice(0, 10) : "");
//               }}
//             />
//           </div>

//           {/* {tab === "invoiced" && (
//             <select
//               value={statusFilter}
//               onChange={(e) => setStatusFilter(e.target.value)}
//               className="h-9 w-20 rounded-xl border border-blue-100 bg-white px-2 text-xs font-semibold"
//             >
//               <option value="all">All</option>
//               <option value="Paid">Paid</option>
//               <option value="Partially Paid">Partial</option>
//               <option value="Unpaid">Unpaid</option>
//               <option value="due">Due</option>
//             </select>
//           )} */}

//           <select
//             value={pageSize}
//             onChange={(e) => setPageSize(Number(e.target.value))}
//             className="h-9 w-20 rounded-xl border border-blue-100 bg-white px-2 text-xs font-semibold"
//           >
//             <option value={5}>5 </option>
//             <option value={10}>10 </option>
//             <option value={20}>20</option>
//             <option value={50}>50</option>
//           </select>
//         </div>

//         {/* ROW 3: RESET | REFRESH */}
//         <div className="flex justify-end gap-2">
//           <button
//             type="button"
//             onClick={onReset}
//             className="h-9 rounded-xl border border-blue-200 bg-white px-3 text-xs font-semibold text-blue-700"
//           >
//             Reset
//           </button>

//           <RefreshButton onClick={onRefresh} />
//         </div>
//       </div>

//       {/* ================= DESKTOP LAYOUT ================= */}
//       <div className="hidden md:flex md:items-center md:justify-end md:gap-3">

//         <div className="w-[240px]">
//           <SearchInput
//             value={search}
//             onChange={setSearch}
//             onClear={() => setSearch("")}
//             placeholder="Search invoice / customer / phone"
//             size="md"
//           />
//         </div>

//         <div className="w-[160px]">
//           <DateRangePicker
//             startDate={fromDate ? new Date(fromDate) : null}
//             endDate={toDate ? new Date(toDate) : null}
//             onChange={(start, end) => {
//               setFromDate(start ? start.toISOString().slice(0, 10) : "");
//               setToDate(end ? end.toISOString().slice(0, 10) : "");
//             }}
//           />
//         </div>

//         {tab === "invoiced" && (
//           <select
//             value={statusFilter}
//             onChange={(e) => setStatusFilter(e.target.value)}
//             className="h-9 w-16 rounded-xl border border-blue-100 bg-white px-2 text-xs font-semibold"
//           >
//             <option value="all">All</option>
//             <option value="Paid">Paid</option>
//             <option value="Partially Paid">Partial</option>
//             <option value="Unpaid">Unpaid</option>
//             <option value="due">Due</option>
//           </select>
//         )}

//         <select
//           value={pageSize}
//           onChange={(e) => setPageSize(Number(e.target.value))}
//           className="h-9 w-24 rounded-xl border border-blue-100 bg-white px-2 text-xs font-semibold"
//         >
//           <option value={5}>5 </option>
//           <option value={10}>10 </option>
//           <option value={20}>20 </option>
//           <option value={50}>50 </option>
//         </select>

//         <button
//           type="button"
//           onClick={onReset}
//           className="h-9 rounded-xl border border-blue-200 bg-white px-3 text-xs font-semibold text-blue-700"
//         >
//           Reset
//         </button>

//         <RefreshButton onClick={onRefresh} />
//       </div>
//     </div>
//   );
// }



// export default function InvoicesView({
//   fromUserView = false,
//   selectedUserId = null,
//   selectedUserRole = null,
// }) {

//   const location = useLocation();
//   // const forwardedState = location.state || {};

//   // const fromUserView = forwardedState.fromUserView === true;
//   // const selectedUserId = forwardedState.selectedUserId || null;
//   // const selectedUserRole = forwardedState.selectedUserRole || null;
//   // console.log("selected user role: ", selectedUserRole);

//   // console.log("id from state: ", selectedUserId);


//   const [invoices, setInvoices] = useState([]);
//   const [uninvoiced, setUninvoiced] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [payoutSummary, setPayoutSummary] = useState({
//   total_sales_invoiced: 0,
//   total_sales_uninvoiced: 0,
//   credit_notes: 0,
//   paid_amount: 0,
//   payable_amount: 0,
//   pending_invoices: { count: 0, amount: 0 },
// });


//   const getRoleBasedParams = () => {
//     const targetId = fromUserView ? selectedUserId : sessionId;
//     const role = effectiveRole;

//     if (!targetId || !role) {
//       console.warn("❌ Missing role or targetId", { role, targetId });
//       return {};
//     }

//     if (role === 2) return { company_id: targetId };
//     if (role === 4) return { agent_id: targetId };
//     if (role === 5) return { retailer_id: targetId };

//     console.warn("❌ Unsupported role:", role);
//     return {};
//   };



//   const resetFilters = () => {
//     setSearch("");
//     setCustomerCode("");
//     setStatusFilter("all");
//     setFromDate("");
//     setToDate("");
//     setCurrentPage(1);
//   };

//   // ✅ company name shown on all pages/tabs
//   const companyObj = location.state?.c || location.state?.company || null;
//   const companyName =
//     companyObj?.business_name ||
//     companyObj?.name ||
//     location.state?.companyName ||
//     "Company";

//   const showOnlyDue = location.state?.showOnlyDue || false;
//   const showOnlyPaid = location.state?.showOnlyPaid || false;

//   // Tabs
//   const [tab, setTab] = useState("invoiced");

//   // Toolbar
//   const [search, setSearch] = useState("");
//   const [customerCode, setCustomerCode] = useState("");
//   const [statusFilter, setStatusFilter] = useState(showOnlyPaid ? "Paid" : showOnlyDue ? "due" : "all");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");

//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);

//   // Modals
//   const [openUninvoiced, setOpenUninvoiced] = useState(false);
//   const [selectedUninvoiced, setSelectedUninvoiced] = useState(null);

//   const [openInvoice, setOpenInvoice] = useState(false);
//   const [selectedInvoice, setSelectedInvoice] = useState(null);
//   const [debouncedSearch, setDebouncedSearch] = useState(search);

//   const [paymentKeys, setPaymentKeys] = useState({
//         key_id: "",
//         key_secret: ""
//       });

//   const [keyLoading, setKeyLoading] = useState(false);
//   const [paymentSaving, setPaymentSaving] = useState(false);

//   const authUserString = localStorage.getItem("authUserData");
//   const authUser = authUserString ? JSON.parse(authUserString) : null;

//   // Logged-in role (sidebar)
//   const sessionRole = Number(authUser?.role);

//   // 🔥 Final role decision
//   const effectiveRole = fromUserView
//     ? Number(selectedUserRole)
//     : sessionRole;


//   const sessionId = authUser?.id;

//   useEffect(() => {
//   const t = setTimeout(() => {
//     setDebouncedSearch(search);
//   }, 500); // ⏳ 500ms debounce

//   return () => clearTimeout(t);
// }, [search]);

      
//   const fetchInvoices = async () => {
//   try {
//     setLoading(true);

//     let endpoint = "warranty/get-devices";
//     const query = new URLSearchParams();

//     // ---- TAB → QUERY PARAMS ----
//     if (tab === "invoiced") {
//       query.append("invoice_status", "invoiced");
//     } else if (tab === "uninvoiced") {
//       query.append("invoice_status", "uninvoiced");
//     } else if (tab === "creditNotes") {
//       query.append("credit_note", "credit_note");
//     }

//     // ---- ROLE BASED PARAM ----
//     const roleParams = getRoleBasedParams();
//     Object.entries(roleParams).forEach(([k, v]) => query.append(k, v));

//     // ---- SEARCH ----
//     if (debouncedSearch) {
//       query.append("search", debouncedSearch);
//     }

//     // ---- DATE FILTER ----
//     if (fromDate) query.append("from_invoice_date", fromDate);
//     if (toDate) query.append("to_invoice_date", toDate);

//     const res = await fetch(`${BASE_URL}${endpoint}?${query.toString()}`);
//     const json = await res.json();

//     const rows =
//   (json?.data || []).map((d) => {
//     // ✅ SAFE PARSE invoice_json
//     let invoiceMeta = null;
//     try {
//       invoiceMeta = d.invoice_json ? JSON.parse(d.invoice_json) : null;
//     } catch (e) {
//       invoiceMeta = null;
//     }

//     return {
//       // ========= COMMON =========
//       rawid:d.id,
//       id:
//         tab === "invoiced"
//           ? d.invoice_id
//           : tab === "creditNotes"
//           ? `CN-${d.id}`
//           : `UNINV-${d.id}`,

//       customerName: d.customer?.name || d.name,
//       customerCode: d.customer?.c_code || "—",
//       phone: d.customer?.mobile,

//       amount: Number(d.product_price || 0),
//       creditNote: Number(d.credit_note || 0),

//       // ========= INVOICE META =========
//       invoice_Code: invoiceMeta?.invoice_number || null,
//       invoiceUrl: invoiceMeta?.invoice_url || null,
//       invoiceBalance: Number(invoiceMeta?.balance ?? null),
//       invoiceStatus: d.invoice_status,

//       // ========= STATUS =========
//       status: getInvoiceStatusLabel(d.invoice_status),
//       paidAmount:
//         tab === "invoiced" && invoiceMeta
//           ? Number(d.product_price || 0) - Number(invoiceMeta.balance || 0)
//           : 0,

//       date: d.invoice_created_date || d.created_at,
//       dueDate: d.expiry_date,

//       // ========= UNINVOICED =========
//       warrantyId: d.w_code,
//       IMEI1: d.imei1,
//       IMEI2: d.imei2,
//       serial: d.serial,
//       model_id: d.model_id,
//       product_id: d.product_id,
//       w_customer_id: d.w_customer_id,
//       warrantyType: d.product_name,
//       billPhoto: d.billPhoto,
//       link1: d.link1,
//       deviceInfo: `${d.brand_name} • ${d.model}`,
//       purchaseDate: d.created_at,

//       // ========= CREDIT NOTE =========
//       creditId: d.credit_note ? `CN-${d.id}` : null,
//       reason: d.note || "Credit Adjustment",
//     };
//   }) || [];


//     if (tab === "invoiced") setInvoices(rows);
//     if (tab === "uninvoiced") setUninvoiced(rows);
//     if (tab === "creditNotes") setInvoices(rows); // reuse invoices state

//   } catch (err) {
//     console.error("❌ Device fetch failed", err);
//   } finally {
//     setLoading(false);
//   };


//     console.log("🧭 Invoice Context", {
//       fromUserView,
//       sessionRole,
//       selectedUserRole,
//       effectiveRole,
//       sessionId,
//       selectedUserId,
//       roleParams: getRoleBasedParams(),
//     });
//   };
//    useEffect(() => {
//   // Clear immediately on tab change
//   setInvoices([]);
//   setUninvoiced([]);
//   setCurrentPage(1);
// }, [tab]);

// useEffect(() => {
//   fetchInvoices();
// }, [tab, debouncedSearch, fromDate, toDate, sessionId, selectedUserId, effectiveRole]);


// function getInvoiceStatusLabel(status) {
//   if (!status) return "Unpaid";

//   if (status === "paid") return "Paid";
//   if (status === "sent") return "Sent";
//   if (status === "partially_paid") return "Partially Paid";

//   return "Unpaid";
// }


// function isPdf(url) {
//   return typeof url === "string" && url.toLowerCase().endsWith(".pdf");
// }

// function getEmptyMessage(tab) {
//   if (tab === "invoiced") return "No invoices found";
//   if (tab === "uninvoiced") return "No pending invoices found";
//   if (tab === "creditNotes") return "No credit notes found";
//   return "No data found";
// }

// const fetchPayoutSummary = async () => {
//   try {
//     const params = new URLSearchParams();
//     const targetId = fromUserView ? selectedUserId : sessionId;

//     if (!targetId || !effectiveRole) return;

//     if (effectiveRole === 2) params.append("company_id", targetId);
//     if (effectiveRole === 4) params.append("agent_id", targetId);
//     if (effectiveRole === 5) params.append("retailer_id", targetId);

//     const res = await fetch(
//       `${BASE_URL}warranty/payout-summary?${params.toString()}`
//     );
//     const json = await res.json();

//     if (!json?.status) return;

//     setPayoutSummary({
//       total_sales_invoiced: Number(json.data?.total_sales_invoiced || 0),
//       total_sales_uninvoiced: Number(json.data?.total_sales_uninvoiced || 0),
//       credit_notes: Number(json.data?.credit_notes || 0),
//       paid_amount: Number(json.data?.paid_amount || 0),
//       payable_amount: Number(json.data?.payable_amount || 0),
//       pending_invoices: {
//         count: Number(json.data?.pending_invoices?.count || 0),
//         amount: Number(json.data?.pending_invoices?.amount || 0),
//       },
//     });
//   } catch (err) {
//     console.error("❌ Payout summary fetch failed", err);
//   }
// };

// useEffect(() => {
//   fetchPayoutSummary();
// }, [effectiveRole, sessionId, selectedUserId, fromUserView]);

//   const creditNotes = useMemo(() => {
//     return invoices
//       .filter((x) => x.creditNote > 0)
//       .map((x) => ({
//         creditId: `CN-${x.id}`,
//         invoiceId: x.id,
//         date: x.date,
//         amount: x.amount,
//         customerName: x.customerName,
//         customerCode: x.customerCode,
//         reason: "Adjustment / Discount",
//       }));
//   }, [invoices]);

//   // KPIs
//   const totals = useMemo(() => {
//     const totalInvoiceAmount = invoices.reduce((sum, inv) => sum + inv.amount, 0);
//     const totalCreditNotes = invoices.reduce((sum, inv) => sum + inv.creditNote, 0);
//     return { totalInvoiceAmount, totalCreditNotes };
//   }, [invoices]);

//   const moneyStats = useMemo(() => ({ payableAmount: 120000, paidAmount: 90000 }), []);

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [tab, search, statusFilter, pageSize, customerCode, fromDate, toDate]);

//   // Filtering
//   const filteredRows = useMemo(() => {
//     const q = search.trim().toLowerCase();
//     const cc = customerCode.trim().toLowerCase();

//     if (tab === "invoiced") {
//       let rows = [...invoices];

//       if (showOnlyPaid) rows = rows.filter((r) => r.status === "paid");
//       if (showOnlyDue) rows = rows.filter((r) => r.status === "Partially Paid" || r.status === "Unpaid");

//       if (statusFilter === "due") {
//         rows = rows.filter((r) => r.status === "Partially Paid" || r.status === "Unpaid");
//       } else if (statusFilter !== "all") {
//         rows = rows.filter((r) => r.status === statusFilter);
//       }

//       rows = rows.filter((r) => isBetween(r.date, fromDate, toDate));
//       if (cc) rows = rows.filter((r) => String(r.customerCode || "").toLowerCase().includes(cc));
//       return rows;
//     }

//     if (tab === "uninvoiced") {
//       let rows = [...uninvoiced];
//       rows = rows.filter((r) => isBetween(r.purchaseDate, fromDate, toDate));
//       if (cc) rows = rows.filter((r) => String(r.customerCode || "").toLowerCase().includes(cc));

//       if (q) {
//         rows = rows.filter((r) =>
//           [r.id, r.customerName, r.customerCode, r.phone, r.warrantyId, r.warrantyType, r.deviceInfo, r.purchaseDate]
//             .filter(Boolean)
//             .join(" ")
//             .toLowerCase()
//             .includes(q)
//         );
//       }
//       return rows;
//     }

//     // creditNotes
//     let rows = [...creditNotes];
//     rows = rows.filter((r) => isBetween(r.date, fromDate, toDate));
//     if (cc) rows = rows.filter((r) => String(r.customerCode || "").toLowerCase().includes(cc));
//     if (q) {
//       rows = rows.filter((r) =>
//         [r.creditId, r.invoiceId, r.customerName, r.customerCode, r.reason, r.date]
//           .filter(Boolean)
//           .join(" ")
//           .toLowerCase()
//           .includes(q)
//       );
//     }
//     return rows;
//   }, [tab, invoices, uninvoiced, creditNotes, search, statusFilter, showOnlyPaid, showOnlyDue, customerCode, fromDate, toDate]);

//   // Pagination
//   const totalPages = Math.max(1, Math.ceil(filteredRows.length / pageSize));
//   const pageRows = useMemo(() => {
//     const start = (currentPage - 1) * pageSize;
//     return filteredRows.slice(start, start + pageSize);
//   }, [filteredRows, currentPage, pageSize]);

//   // Actions
//   const onViewInvoice = (row) => {
//     setSelectedInvoice(row);
//     setOpenInvoice(true);
//   };

//   const onViewUninvoiced = (row) => {
//     setSelectedUninvoiced(row);
//     setOpenUninvoiced(true);
//   };

//   const tabTitle =
//     tab === "invoiced" ? "Invoice List" : tab === "uninvoiced" ? "Uninvoiced" : "Credit Notes";

  
//   const fetchPaymentKeys = async () => {
//     try {
//       setKeyLoading(true);
  
//       const res = await fetch(`${BASE_URL}payment/keys`);
//       const data = await res.json();
  
//       if (Array.isArray(data) && data.length > 0) {
//         setPaymentKeys({
//           key_id: data[0].key_id,
//           key_secret: data[0].key_secret
//         });
//       } else {
//         console.error("Invalid keys response", data);
//       }
//     } catch (err) {
//       console.error("Failed to fetch payment keys", err);
//     } finally {
//       setKeyLoading(false);
//     }
//   };
  
//     useEffect(() => {
//       fetchPaymentKeys();
//   }, []);

//   const handlePayNow = async (row) => {
//   if (!paymentKeys?.key_id) {
//     toast.error("Payment keys not loaded");
//     return;
//   }

//   // 💰 amount from invoice row
//   const amount = Number(row.amount || 0);
//   const roundedAmount = Math.round(amount * 100); // paise

//   // 🧾 Notes built from ROW
//   const notes = {
//     project: "warranty",
//     service: "update",
//     imei1: row.IMEI1,
//     imei2: row.IMEI2,
//     serial:row.serial,
//     product_id:row.product_id,
//     model_id:row.model_id,
//     company_id: authUser?.company_id,
//     retailer_id: sessionId,
//     agent_id: authUser?.agent_id,
//     amount: amount,
//     // warranty_id: row.warrantyId || null,
//     // invoice_id: row.id || null,
//     w_customer_id:row.w_customer_id,
//     created_by: sessionId,
//     document_url: row.billPhoto,
//     device_id: row.rawid,
//   };

//   const options = {
//     key: paymentKeys.key_id,
//     amount: roundedAmount,
//     currency: "INR",
//     name: "GO Electronix",
//     description: `Invoice Payment - ${row.invoice_Code || row.id}`,
//     notes,

//     handler: async function (response) {
//       try {
//         setPaymentSaving(true);

//         console.log("✅ Razorpay Success:", response);
//         console.log("📦 Paid Row:", row);

//         const payload = {
//           payment_id: response.razorpay_payment_id,

//           invoice_id: row.id,
//           invoice_code: row.invoice_Code,

//           amount,
//           customer_name: row.customerName,
//           customer_code: row.customerCode,

//           retailer_id: sessionId,
//           company_id: authUser?.company_id,

//           source: "invoice_pay_now",
//         };

//         console.log("🚀 Payment Payload:", payload);

//         toast.success("Payment successful 🎉");

//         // 🔁 Refresh invoices after payment
//         fetchInvoices();
//         fetchPayoutSummary();
//       } catch (err) {
//         console.error(err);
//         toast.error("Payment succeeded but processing failed");
//       } finally {
//         setPaymentSaving(false);
//       }
//     },

//     prefill: {
//       name: row.customerName || "",
//       contact: row.phone || "",
//     },

//     theme: { color: "#2563eb" },
//   };

//   const rzp = new window.Razorpay(options);
//   rzp.open();
// };



//   return (
//     <div className="space-y-4">
//       {/* ✅ Company header always */}
//       {/* <div className="rounded-2xl border border-blue-100 bg-white p-4 shadow-sm">
//         <div className="flex flex-wrap items-center justify-between gap-3">
//           <div className="flex items-center gap-3">
//             <div className="rounded-2xl bg-blue-50 p-3 text-blue-700">
//               <Building2 className="h-5 w-5" />
//             </div>
//             <div>
//               <p className="text-xs font-semibold text-slate-500">Company</p>
//               <p className="text-base font-semibold text-slate-900">{companyName}</p>
//             </div>
//           </div>
//           <div className="text-xs font-semibold text-slate-500">
//             Records: <span className="font-semibold text-slate-900">{filteredRows.length}</span>
//           </div>
//         </div>
//       </div> */}

//       {/* KPI Cards */}
//      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
//         <KpiCard
//           label="Invoice Amount"
//           value={money(payoutSummary.total_sales_invoiced)}
//           subLabel="Total invoiced"
//           icon={FileSpreadsheet}
//         />

//         <KpiCard
//           label="Uninvoiced"
//           value={money(payoutSummary.total_sales_uninvoiced)}
//           subLabel="Pending billing"
//           icon={FileBarChart2}
//         />

//         <KpiCard
//           label="Credit Notes"
//           value={money(payoutSummary.credit_notes)}
//           subLabel={`${payoutSummary.pending_invoices.count} pending invoices`}
//           icon={FileText}
//         />

//         <KpiCard
//           label="Paid Amount"
//           value={money(payoutSummary.paid_amount)}
//           subLabel={`Payable: ${money(payoutSummary.payable_amount)}`}
//           icon={Wallet}
//         />
//       </div>


//       {/* Tabs */}
//       <div className="flex gap-2 overflow-x-auto rounded-2xl border border-blue-100 bg-white p-2">
//         {TABS.map((t) => (
//           <button
//             key={t.key}
//             type="button"
//             onClick={() => setTab(t.key)}
//             className={classNames(
//               "whitespace-nowrap rounded-xl px-4 py-2 text-sm font-semibold transition",
//               tab === t.key ? "bg-blue-600 text-white" : "bg-blue-50 text-blue-700 hover:bg-blue-100"
//             )}
//           >
//             {t.label}
//           </button>
//         ))}
//       </div>

//       <SectionCard title={tabTitle}>
       
//         <div className="mt-3 flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
//           {/* Filters / Toolbar */}
//           <div className="flex-1">
//             <TableToolbar
//               tab={tab}
//               search={search}
//               setSearch={setSearch}
//               customerCode={customerCode}
//               setCustomerCode={setCustomerCode}
//               statusFilter={statusFilter}
//               setStatusFilter={setStatusFilter}
//               fromDate={fromDate}
//               setFromDate={setFromDate}
//               toDate={toDate}
//               setToDate={setToDate}
//               pageSize={pageSize}
//               setPageSize={setPageSize}
//               onReset={resetFilters}
//               onRefresh={fetchInvoices}
//             />
            
//           </div>

//           {/* Refresh Button */}
          

//         </div>

//         {/* ================= DESKTOP TABLE ================= */}
//         <div className="hidden lg:block">
//           {loading ? (
//             <div className="flex justify-center items-center py-16">
//               <RegularLoader />
//             </div>
//           ) : filteredRows.length === 0 ? (
//             <div className="flex flex-col items-center justify-center py-20 text-center">
//               <FileText className="h-10 w-10 text-slate-300 mb-3" />
//               <p className="text-sm font-semibold text-slate-600">
//                 {getEmptyMessage(tab)}
//               </p>
//             </div>
//           ) : (

//           <SimpleTable  
//             headers={
//               tab === "invoiced"
//                 ? ["Invoice", "Customer", "Customer Code", "Amount", "Status", "Invoice Date"]
//                 : tab === "uninvoiced"
//                 ? ["Ref", "Customer", "Customer Code", "Phone", "Warranty", "Purchase Date", "Amount", "Status"]
//                 : ["Credit Note", "Invoice", "Customer", "Customer Code", "Amount", "Date", "Reason"]
//             }
//             rows={pageRows.map((row) => {
//               if (tab === "invoiced") {
//                 return {
//                   raw: row,
//                   cells: [
//                     row.invoice_Code,
//                     row.customerName,
//                     row.customerCode || "—",
//                     money(row.amount),
//                    <Badge variant={statusBadgeVariant(row.status)}>
//                       {row.status}
//                     </Badge>,
//                     // money(row.paidAmount),
//                     // money(row.creditNote),
//                     formatDateTime(row.date),
//                   ],

//                 };
//               }

//               if (tab === "uninvoiced") {
//                 return {
//                   raw: row,
//                   cells: [
//                     row.id,
//                     row.customerName,
//                     row.customerCode || "—",
//                     row.phone,
//                     {
//                       title: row.warrantyId,
//                       sub: row.warrantyType,
//                     },
//                     formatDateTime(row.purchaseDate),
//                     money(row.amount),
//                     <Badge variant={statusBadgeVariant(row.status)}>
//                       {row.status}
//                     </Badge>,
//                   ],
//                 };
//               }

//               return {
//                 raw: row,
//                 cells: [
//                   row.creditId,
//                   row.invoiceId,
//                   row.customerName,
//                   row.customerCode || "—",
//                    money(row.amount),
//                   formatDateTime(row.date),
//                   row.reason,
//                 ],
//               };
//             })}
//             renderActions={(row) => {
//             const isInvoiced = tab === "invoiced";
//             const isPaid = row.invoiceStatus === "paid";

//             return (
//               <div className="flex items-center gap-2 justify-center">

//                 {/* PAY NOW (only if not paid) */}
//                 {isInvoiced && !isPaid && (
//                 // {!isPaid && (
//                   <button
//                     onClick={() => handlePayNow(row)}
//                     className="inline-flex items-center gap-2 rounded-xl bg-emerald-600 px-3 py-2 text-xs font-semibold text-white hover:bg-emerald-700"
//                   >
//                     Pay Now
//                   </button>
//                 )}

//                 {/* VIEW */}
//                 <button
//                   onClick={() =>
//                     tab === "uninvoiced"
//                       ? onViewUninvoiced(row)
//                       : onViewInvoice(row)
//                   }
//                   className="inline-flex items-center gap-2 rounded-xl border border-blue-200 bg-blue-50 px-3 py-2 text-xs font-semibold text-blue-700 hover:bg-blue-100"
//                 >
//                   <Eye className="h-4 w-4" />
//                   View
//                 </button>

                
//               </div>
//             );
//           }}

//             currentPage={currentPage}
//             totalPages={totalPages}
//             onPageChange={setCurrentPage}
//             align="center"
//           />
//            )}
//           </div>


//         {/* ================= MOBILE / TABLET CARDS ================= */}
//        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 lg:hidden">
//           {/* 🔄 LOADING */}
//           {loading ? (
//             <div className="col-span-full flex justify-center py-16">
//               <RegularLoader />
//             </div>
//           ) : pageRows.length === 0 ? (
//             /* 📭 EMPTY STATE */
//             <div className="col-span-full flex flex-col items-center justify-center py-20 text-center">
//               <FileText className="h-10 w-10 text-slate-300 mb-3" />
//               <p className="text-sm font-semibold text-slate-600">
//                 {getEmptyMessage(tab)}
//               </p>
//             </div>
//           ) : (
//             /* 📱 DATA CARDS */
//             <>
//               {pageRows
//                 .filter((row) => {
//                   if (tab === "invoiced") return !!row.status;
//                   if (tab === "uninvoiced") return !!row.warrantyId;
//                   if (tab === "creditNotes") return !!row.creditId;
//                   return false;
//                 })
//                 .map((row) => (
//                   <InvoiceMobileCard
//                     key={row.id || row.creditId}
//                     row={row}
//                     tab={tab}
//                     onPayNow={handlePayNow}
//                     money={money}
//                     formatDateTime={formatDateTime}
//                     onViewInvoice={onViewInvoice}
//                     onViewUninvoiced={onViewUninvoiced}
//                   />
//                 ))}

//               {totalPages > 1 && (
//                 <div className="col-span-full">
//                   <Pagination
//                     currentPage={currentPage}
//                     totalPages={totalPages}
//                     onPageChange={setCurrentPage}
//                   />
//                 </div>
//               )}
//             </>
//           )}
//         </div>

//         {totalPages > 1 && (
//           <div className="mt-4 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
//             <div className="text-xs font-semibold text-slate-500">
//               Page <span className="font-semibold text-slate-900">{currentPage}</span> of{" "}
//               <span className="font-semibold text-slate-900">{totalPages}</span>
//             </div>
//             <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
//           </div>
//         )}
//       </SectionCard>

//       {/* ✅ Uninvoiced Details Modal */}
//       <Modal
//         open={openUninvoiced}
//         title="Uninvoiced Details"
//         onClose={() => {
//           setOpenUninvoiced(false);
//           setSelectedUninvoiced(null);
//         }}
//       >
//         {selectedUninvoiced ? (
//           <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
//             {[
//               ["Customer Name", selectedUninvoiced.customerName],
//               ["Customer Code", selectedUninvoiced.customerCode || "—"],
//               ["Phone No", selectedUninvoiced.phone],
//               ["Warranty ID", selectedUninvoiced.warrantyId],
//               ["Type of Warranty", selectedUninvoiced.warrantyType],
//               ["Purchase Date", selectedUninvoiced.purchaseDate],
//               ["Amount", money(selectedUninvoiced.amount)],
//             ].map(([k, v]) => (
//               <div key={k} className="rounded-xl border border-blue-100 bg-white p-3">
//                 <p className="text-xs font-semibold text-slate-500">{k}</p>
//                 <p className="text-sm font-semibold text-slate-900">{v}</p>
//               </div>
//             ))}

//             <div className="rounded-xl border border-blue-100 bg-white p-3 md:col-span-2">
//               <p className="text-xs font-semibold text-slate-500">Device Info</p>
//               <p className="text-sm font-semibold text-slate-900">{selectedUninvoiced.deviceInfo}</p>
//             </div>

//             <div className="mt-2 flex justify-end md:col-span-2">
//               <button
//                 type="button"
//                 onClick={() => {
//                   setOpenUninvoiced(false);
//                   setSelectedUninvoiced(null);
//                 }}
//                 className="inline-flex items-center gap-2 rounded-xl border border-blue-200 bg-blue-50 px-4 py-2 text-sm font-semibold text-blue-700 hover:bg-blue-100"
//               >
//                 <ArrowLeft className="h-4 w-4" />
//                 Previous
//               </button>
//             </div>
//           </div>
//         ) : null}
//       </Modal>

//       {/* ✅ Invoice View Modal Layout + Previous button restored */}
//       <Modal
//         open={openInvoice}
//         title="Invoice View"
//         onClose={() => {
//           setOpenInvoice(false);
//           setSelectedInvoice(null);
//         }}
//       >
//         {selectedInvoice ? (
//           <div className="space-y-4">
//             <div className="rounded-2xl border border-blue-100 bg-blue-50 p-4">
//               <div className="flex flex-wrap items-start justify-between gap-3">
//                 <div>
//                   <p className="text-xs font-semibold text-slate-500">Invoice</p>
//                   <p className="text-sm font-semibold text-slate-900">{selectedInvoice.id}</p>
//                   {"customerName" in selectedInvoice ? (
//                     <p className="mt-1 text-xs font-semibold text-slate-600">
//                       Customer: <span className="font-semibold text-slate-900">{selectedInvoice.customerName}</span>
//                       {"customerCode" in selectedInvoice && selectedInvoice.customerCode ? (
//                         <>
//                           {" "}
//                           • Code: <span className="font-semibold text-slate-900">{selectedInvoice.customerCode}</span>
//                         </>
//                       ) : null}
//                     </p>
//                   ) : null}
//                 </div>

//                 {"status" in selectedInvoice ? (
//                   <div className="flex items-center gap-2">
//                     <Badge variant={statusBadgeVariant(selectedInvoice.status)}>{selectedInvoice.status}</Badge>
//                   </div>
//                 ) : null}
//               </div>

//               <div className="mt-3 grid grid-cols-1 gap-3 md:grid-cols-3">
//                 {"amount" in selectedInvoice ? (
//                   <div className="rounded-xl border border-blue-100 bg-white p-3">
//                     <p className="text-xs font-semibold text-slate-500">Amount</p>
//                     <p className="text-sm font-semibold text-slate-900">{money(selectedInvoice.amount)}</p>
//                   </div>
//                 ) : null}

//                 {"paidAmount" in selectedInvoice ? (
//                   <div className="rounded-xl border border-blue-100 bg-white p-3">
//                     <p className="text-xs font-semibold text-slate-500">Paid</p>
//                     <p className="text-sm font-semibold text-slate-900">{money(selectedInvoice.paidAmount)}</p>
//                   </div>
//                 ) : null}

//                 {"creditNote" in selectedInvoice ? (
//                   <div className="rounded-xl border border-blue-100 bg-white p-3">
//                     <p className="text-xs font-semibold text-slate-500">Credit Note</p>
//                     <p className="text-sm font-semibold text-slate-900">{money(selectedInvoice.creditNote)}</p>
//                   </div>
//                 ) : null}
//               </div>
//             </div>

//             {/* PDF / Preview area */}
//             <div className="rounded-2xl border border-blue-100 bg-white p-4 space-y-3">
//               <div className="flex items-center justify-between">
//                 <p className="text-sm font-semibold text-slate-900">Invoice Preview</p>

//                 {selectedInvoice?.invoiceUrl && (
//                   <a
//                     href={selectedInvoice.invoiceUrl}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="rounded-lg border border-blue-200 bg-blue-50 px-3 py-1 text-xs font-semibold text-blue-700 hover:bg-blue-100"
//                   >
//                     Open in new tab
//                   </a>
//                 )}
//               </div>

//               {selectedInvoice?.invoiceUrl ? (
//                 <iframe
//                   src={`${selectedInvoice.invoiceUrl}#toolbar=0&navpanes=0`}
//                   title="Invoice PDF"
//                   className="h-[60vh] md:h-[520px] w-full rounded-xl border border-blue-100"
//                 />
//               ) : (
//                 <div className="rounded-xl border border-dashed border-slate-300 bg-slate-50 p-6 text-center text-sm font-semibold text-slate-500">
//                   Invoice preview not available
//                 </div>
//               )}
//             </div>

//             <div className="flex justify-end">
//               <button
//                 type="button"
//                 onClick={() => {
//                   setOpenInvoice(false);
//                   setSelectedInvoice(null);
//                 }}
//                 className="inline-flex items-center gap-2 rounded-xl border border-blue-200 bg-blue-50 px-4 py-2 text-sm font-semibold text-blue-700 hover:bg-blue-100"
//               >
//                 <ArrowLeft className="h-4 w-4" />
//                 Previous
//               </button>
//             </div>
//           </div>
//         ) : null}
//       </Modal>
//     </div>
//   );
// }

// import React, { useMemo, useState } from "react";
// import { useLocation } from "react-router-dom";
// import { KpiCard } from "../../../Component/RetailerMainComponents/KpiCard";
// import { SectionCard } from "../../../Component/RetailerMainComponents/SectionCard";
// import {
//   FileSpreadsheet,
//   FileBarChart2,
//   FileText,
//   Wallet
// } from "lucide-react";
// import { Badge } from "../../../Component/RetailerMainComponents/Badge";
// import Pagination from "../../../Component/Common/Pagination";
// import RefreshButton from "../../../Component/Common/RefreshButton";


// export default function InvoicesView() {
//   const location = useLocation();
//   const showOnlyDue = location.state?.showOnlyDue || false;
//   const showOnlyPaid = location.state?.showOnlyPaid || false;

//   // Pagination state
//   const [currentPage, setCurrentPage] = useState(1);
//   const ITEMS_PER_PAGE = 1;

//   const invoices = [
//     {
//       id: "INV-2025-001",
//       date: "2025-10-02",
//       amount: 25000,
//       status: "Paid",
//       paidAmount: 25000,
//       creditNote: 0,
//       dueDate: "2025-10-15",
//     },
//     {
//       id: "INV-2025-002",
//       date: "2025-10-10",
//       amount: 40000,
//       status: "Partially Paid",
//       paidAmount: 25000,
//       creditNote: 5000,
//       dueDate: "2025-10-25",
//     },
//     {
//       id: "INV-2025-003",
//       date: "2025-10-18",
//       amount: 35000,
//       status: "Unpaid",
//       paidAmount: 0,
//       creditNote: 0,
//       dueDate: "2025-11-05",
//     },
//     {
//       id: "INV-2025-004",
//       date: "2025-11-02",
//       amount: 50000,
//       status: "Paid",
//       paidAmount: 50000,
//       creditNote: 3000,
//       dueDate: "2025-11-15",
//     },
//   ];

//   // ⭐ FILTER BASED ON KPI CLICK
//   const filteredInvoices = useMemo(() => {
//     if (showOnlyPaid) {
//       return invoices.filter(inv => inv.status === "Paid");
//     }

//     if (showOnlyDue) {
//       return invoices.filter(
//         inv => inv.status === "Partially Paid" || inv.status === "Unpaid"
//       );
//     }

//     return invoices;
//   }, [showOnlyDue, showOnlyPaid]);


//   // ⭐ PAGINATION LOGIC
//   const totalPages = Math.ceil(filteredInvoices.length / ITEMS_PER_PAGE);

//   const paginatedInvoices = useMemo(() => {
//     const start = (currentPage - 1) * ITEMS_PER_PAGE;
//     return filteredInvoices.slice(start, start + ITEMS_PER_PAGE);
//   }, [currentPage, filteredInvoices]);

//   // Money Stats
//   const moneyStats = {
//     payableAmount: 120000,
//     paidAmount: 90000,
//   };

//   const totals = useMemo(() => {
//     const totalInvoiceAmount = invoices.reduce((sum, inv) => sum + inv.amount, 0);
//     const totalPaid = invoices.reduce((sum, inv) => sum + inv.paidAmount, 0);
//     const totalCreditNotes = invoices.reduce((sum, inv) => sum + inv.creditNote, 0);

//     return { totalInvoiceAmount, totalPaid, totalCreditNotes };
//   }, []);

//   return (
//     <div className="space-y-4">
//       {/* KPI CARDS */}
//       <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
//         <KpiCard
//           label="Invoice Amount"
//           value={`₹${totals.totalInvoiceAmount.toLocaleString()}`}
//           subLabel="Total invoiced"
//           icon={FileSpreadsheet}
//         />

//         <KpiCard
//           label="Uninvoiced Amount"
//           value={`₹${(moneyStats.payableAmount - moneyStats.paidAmount).toLocaleString()}`}
//           subLabel="Approx pending billing"
//           icon={FileBarChart2}
//         />

//         <KpiCard
//           label="Credit Notes"
//           value={`₹${totals.totalCreditNotes.toLocaleString()}`}
//           subLabel="Issued adjustments"
//           icon={FileText}
//         />

//         <KpiCard
//           label="Paid vs Payable"
//           value={`₹${moneyStats.paidAmount.toLocaleString()}`}
//           subLabel={`Payable: ₹${moneyStats.payableAmount.toLocaleString()}`}
//           icon={Wallet}
//         />
//       </div>

//       {/* INVOICE TABLE */}
//       <SectionCard title={showOnlyDue ? "Pending Invoices" : "Invoice List"}>
//         <div className="flex justify-end">
//           <RefreshButton/>
//         </div>
//         <div className="overflow-x-auto">
//           <table className="w-full text-sm">
//             <thead>
//               <tr className="text-left border-b">
//                 <th className="py-2">Invoice</th>
//                 <th>Amount</th>
//                 <th>Status</th>
//                 <th>Paid</th>
//                 <th>Credit Note</th>
//                 <th>Due Date</th>
//               </tr>
//             </thead>

//             <tbody>
//               {paginatedInvoices.map((inv) => (
//                 <tr key={inv.id} className="border-b hover:bg-slate-50">
//                   <td className="py-2">{inv.id}</td>
//                   <td>₹{inv.amount.toLocaleString()}</td>

//                   <td>
//                     <Badge
//                       variant={
//                         inv.status === "Paid"
//                           ? "success"
//                           : inv.status === "Partially Paid"
//                           ? "warning"
//                           : "danger"
//                       }
//                     >
//                       {inv.status}
//                     </Badge>
//                   </td>

//                   <td>₹{inv.paidAmount.toLocaleString()}</td>
//                   <td>₹{inv.creditNote.toLocaleString()}</td>
//                   <td>{inv.dueDate}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {/* PAGINATION */}
//         {totalPages > 1 && (
//           <div className="mt-3">
//             <Pagination
//               currentPage={currentPage}
//               totalPages={totalPages}
//               onPageChange={setCurrentPage}
//             />
//           </div>
//         )}
//       </SectionCard>
//     </div>
//   );
// }



// import React, { useMemo } from "react";
// import { useLocation } from "react-router-dom";
// import { KpiCard } from "../../../Component/RetailerMainComponents/KpiCard";
// import { SectionCard } from "../../../Component/RetailerMainComponents/SectionCard";
// import {
//   FileSpreadsheet,
//   FileBarChart2,
//   FileText,
//   Wallet
// } from "lucide-react";
// import { Badge } from "../../../Component/RetailerMainComponents/Badge";

// export default function InvoicesView() {
//   const location = useLocation();
//   const showOnlyDue = location.state?.showOnlyDue || false;

//   const invoices = [
//     {
//       id: "INV-2025-001",
//       date: "2025-10-02",
//       amount: 25000,
//       status: "Paid",
//       paidAmount: 25000,
//       creditNote: 0,
//       dueDate: "2025-10-15",
//     },
//     {
//       id: "INV-2025-002",
//       date: "2025-10-10",
//       amount: 40000,
//       status: "Partially Paid",
//       paidAmount: 25000,
//       creditNote: 5000,
//       dueDate: "2025-10-25",
//     },
//     {
//       id: "INV-2025-003",
//       date: "2025-10-18",
//       amount: 35000,
//       status: "Unpaid",
//       paidAmount: 0,
//       creditNote: 0,
//       dueDate: "2025-11-05",
//     },
//     {
//       id: "INV-2025-004",
//       date: "2025-11-02",
//       amount: 50000,
//       status: "Paid",
//       paidAmount: 50000,
//       creditNote: 3000,
//       dueDate: "2025-11-15",
//     },
//   ];

//   // ⭐ FILTER WHEN COMING FROM KPI
//   const filteredInvoices = useMemo(() => {
//     if (!showOnlyDue) return invoices;
//     return invoices.filter(
//       (inv) => inv.status === "Partially Paid" || inv.status === "Unpaid"
//     );
//   }, [showOnlyDue]);

//   // Money Stats
//   const moneyStats = {
//     payableAmount: 120000,
//     paidAmount: 90000,
//   };

//   const totals = useMemo(() => {
//     const totalInvoiceAmount = invoices.reduce((sum, inv) => sum + inv.amount, 0);
//     const totalPaid = invoices.reduce((sum, inv) => sum + inv.paidAmount, 0);
//     const totalCreditNotes = invoices.reduce((sum, inv) => sum + inv.creditNote, 0);

//     return { totalInvoiceAmount, totalPaid, totalCreditNotes };
//   }, []);

//   return (
//     <div className="space-y-4">
//       <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
//         <KpiCard
//           label="Invoice Amount"
//           value={`₹${totals.totalInvoiceAmount.toLocaleString()}`}
//           subLabel="Total invoiced"
//           icon={FileSpreadsheet}
//         />

//         <KpiCard
//           label="Uninvoiced Amount"
//           value={`₹${(moneyStats.payableAmount - moneyStats.paidAmount).toLocaleString()}`}
//           subLabel="Approx pending billing"
//           icon={FileBarChart2}
//         />

//         <KpiCard
//           label="Credit Notes"
//           value={`₹${totals.totalCreditNotes.toLocaleString()}`}
//           subLabel="Issued adjustments"
//           icon={FileText}
//         />

//         <KpiCard
//           label="Paid vs Payable"
//           value={`₹${moneyStats.paidAmount.toLocaleString()}`}
//           subLabel={`Payable: ₹${moneyStats.payableAmount.toLocaleString()}`}
//           icon={Wallet}
//         />
//       </div>

//       <SectionCard title={showOnlyDue ? "Pending Invoices" : "Invoice List"}>
//         <div className="overflow-x-auto">
//           <table className="w-full text-sm">
//             <thead>
//               <tr className="text-left border-b">
//                 <th className="py-2">Invoice</th>
//                 <th>Amount</th>
//                 <th>Status</th>
//                 <th>Paid</th>
//                 <th>Credit Note</th>
//                 <th>Due Date</th>
//               </tr>
//             </thead>

//             <tbody>
//               {filteredInvoices.map((inv) => (
//                 <tr key={inv.id} className="border-b hover:bg-slate-50">
//                   <td className="py-2">{inv.id}</td>
//                   <td>₹{inv.amount.toLocaleString()}</td>

//                   <td>
//                     <Badge
//                       variant={
//                         inv.status === "Paid"
//                           ? "success"
//                           : inv.status === "Partially Paid"
//                           ? "warning"
//                           : "danger"
//                       }
//                     >
//                       {inv.status}
//                     </Badge>
//                   </td>

//                   <td>₹{inv.paidAmount.toLocaleString()}</td>
//                   <td>₹{inv.creditNote.toLocaleString()}</td>
//                   <td>{inv.dueDate}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </SectionCard>
//     </div>
//   );
// }



// import React, { useMemo } from "react";
// import { KpiCard } from "../../../Component/RetailerMainComponents/KpiCard";
// import { SectionCard } from "../../../Component/RetailerMainComponents/SectionCard";
// import {
//   FileSpreadsheet,
//   FileBarChart2,
//   FileText,
//   Wallet
// } from "lucide-react";
// import { Badge } from "../../../Component/RetailerMainComponents/Badge";

// export default function InvoicesView() {

//   // ✅ DIRECT DATA INSIDE THIS FILE (NO PROPS)
//   const invoices = [
//     {
//       id: "INV-2025-001",
//       date: "2025-10-02",
//       amount: 25000,
//       status: "Paid",
//       paidAmount: 25000,
//       creditNote: 0,
//       dueDate: "2025-10-15",
//     },
//     {
//       id: "INV-2025-002",
//       date: "2025-10-10",
//       amount: 40000,
//       status: "Partially Paid",
//       paidAmount: 25000,
//       creditNote: 5000,
//       dueDate: "2025-10-25",
//     },
//     {
//       id: "INV-2025-003",
//       date: "2025-10-18",
//       amount: 35000,
//       status: "Unpaid",
//       paidAmount: 0,
//       creditNote: 0,
//       dueDate: "2025-11-05",
//     },
//     {
//       id: "INV-2025-004",
//       date: "2025-11-02",
//       amount: 50000,
//       status: "Paid",
//       paidAmount: 50000,
//       creditNote: 3000,
//       dueDate: "2025-11-15",
//     },
//   ];

//   const moneyStats = {
//     payableAmount: 120000,
//     paidAmount: 90000,
//   };

//   const totals = useMemo(() => {
//     const totalInvoiceAmount = invoices.reduce((sum, inv) => sum + inv.amount, 0);
//     const totalPaid = invoices.reduce((sum, inv) => sum + inv.paidAmount, 0);
//     const totalCreditNotes = invoices.reduce((sum, inv) => sum + inv.creditNote, 0);

//     return { totalInvoiceAmount, totalPaid, totalCreditNotes };
//   }, []);

//   return (
//     <div className="space-y-4">

//       {/* KPI CARDS */}
//       <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
//         <KpiCard
//           label="Invoice Amount"
//           value={`₹${totals.totalInvoiceAmount.toLocaleString()}`}
//           subLabel="Total invoiced"
//           icon={FileSpreadsheet}
//         />

//         <KpiCard
//           label="Uninvoiced Amount"
//           value={`₹${(moneyStats.payableAmount - moneyStats.paidAmount).toLocaleString()}`}
//           subLabel="Approx pending billing"
//           icon={FileBarChart2}
//         />

//         <KpiCard
//           label="Credit Notes"
//           value={`₹${totals.totalCreditNotes.toLocaleString()}`}
//           subLabel="Issued adjustments"
//           icon={FileText}
//         />

//         <KpiCard
//           label="Paid vs Payable"
//           value={`₹${moneyStats.paidAmount.toLocaleString()}`}
//           subLabel={`Payable: ₹${moneyStats.payableAmount.toLocaleString()}`}
//           icon={Wallet}
//         />
//       </div>

//       {/* INVOICE TABLE */}
//       <SectionCard title="Invoice List">
//         <div className="overflow-x-auto">
//           <table className="w-full text-sm">
//             <thead>
//               <tr className="text-left border-b">
//                 <th className="py-2">Invoice</th>
//                 <th>Amount</th>
//                 <th>Status</th>
//                 <th>Paid</th>
//                 <th>Credit Note</th>
//                 <th>Due Date</th>
//               </tr>
//             </thead>

//             <tbody>
//               {invoices.map((inv) => (
//                 <tr key={inv.id} className="border-b hover:bg-slate-50">
//                   <td className="py-2">{inv.id}</td>
//                   <td>₹{inv.amount.toLocaleString()}</td>

//                   <td>
//                     <Badge
//                       variant={
//                         inv.status === "Paid"
//                           ? "success"
//                           : inv.status === "Partially Paid"
//                           ? "warning"
//                           : "danger"
//                       }
//                     >
//                       {inv.status}
//                     </Badge>
//                   </td>

//                   <td>₹{inv.paidAmount.toLocaleString()}</td>
//                   <td>₹{inv.creditNote.toLocaleString()}</td>
//                   <td>{inv.dueDate}</td>
//                 </tr>
//               ))}
//             </tbody>

//           </table>
//         </div>
//       </SectionCard>

//     </div>
//   );
// }



// import react, { useMemo } from "react";
// import { KpiCard } from "../../../Component/RetailerMainComponents/KpiCard";
// import { SectionCard } from "../../../Component/RetailerMainComponents/SectionCard";
// import { FileDown,FileSpreadsheet,FileBarChart2, FileText,Wallet } from "lucide-react";
// import { Badge } from "../../../Component/RetailerMainComponents/Badge";
// export default function InvoicesView({ invoices, moneyStats }) {
//   const totals = useMemo(() => {
//     const totalInvoiceAmount = invoices.reduce(
//       (sum, inv) => sum + (inv.amount || 0),
//       0
//     );
//     const totalPaid = invoices.reduce(
//       (sum, inv) => sum + (inv.paidAmount || 0),
//       0
//     );
//     const totalCreditNotes = invoices.reduce(
//       (sum, inv) => sum + (inv.creditNote || 0),
//       0
//     );
//     return { totalInvoiceAmount, totalPaid, totalCreditNotes };
//   }, [invoices]);

//   return (
//     <div className="space-y-4">
//       <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
//         <KpiCard
//           label="Invoice Amount"
//           value={`₹${totals.totalInvoiceAmount.toLocaleString()}`}
//           subLabel="Total invoiced"
//           icon={FileSpreadsheet}
//         />
//         <KpiCard
//           label="Uninvoiced Amount"
//           value={`₹${moneyStats.pendingPayment.toLocaleString()}`}
//           subLabel="Approx pending billing"
//           icon={FileBarChart2}
//         />
//         <KpiCard
//           label="Credit Notes"
//           value={`₹${totals.totalCreditNotes.toLocaleString()}`}
//           subLabel="Issued adjustments"
//           icon={FileText}
//         />
//         <KpiCard
//           label="Paid vs Payable"
//           value={`₹${moneyStats.paid.toLocaleString()}`}
//           subLabel={`Payable: ₹${moneyStats.payable.toLocaleString()}`}
//           icon={Wallet}
//         />
//       </div>

//       <SectionCard
//         title="Invoice List"
//         right={
//           <div className="flex items-center gap-2">
//             <button className="text-[11px] px-2.5 py-1.5 rounded-lg border border-blue-200 text-blue-700 bg-blue-50 hover:bg-blue-100 inline-flex items-center gap-1">
//               <FileDown className="w-3 h-3" />
//               <span>Download statement</span>
//             </button>
//           </div>
//         }
//       >
//         <div className="overflow-x-auto">
//           <table className="min-w-full text-xs">
//             <thead>
//               <tr className="border-b border-slate-100 text-slate-500">
//                 <th className="py-2 text-left">Invoice</th>
//                 <th className="py-2 text-left">Date</th>
//                 <th className="py-2 text-right">Amount</th>
//                 <th className="py-2 text-right">Paid</th>
//                 <th className="py-2 text-right">Credit Note</th>
//                 <th className="py-2 text-left">Status</th>
//                 <th className="py-2 text-left">Due Date</th>
//               </tr>
//             </thead>
//             <tbody>
//               {invoices.map((inv) => {
//                 const statusBadgeColor =
//                   inv.status === "Paid"
//                     ? "green"
//                     : inv.status === "Partially Paid"
//                     ? "yellow"
//                     : "red";
//                 return (
//                   <tr
//                     key={inv.id}
//                     className="border-b border-slate-50 bg-white hover:bg-blue-50/60"
//                   >
//                     <td className="py-1.5 text-xs text-slate-700 font-medium">
//                       {inv.id}
//                     </td>
//                     <td className="py-1.5 text-xs text-slate-700">{inv.date}</td>
//                     <td className="py-1.5 text-xs text-right text-slate-700">
//                       ₹{inv.amount.toLocaleString()}
//                     </td>
//                     <td className="py-1.5 text-xs text-right text-blue-700">
//                       ₹{inv.paidAmount.toLocaleString()}
//                     </td>
//                     <td className="py-1.5 text-xs text-right text-slate-700">
//                       ₹{inv.creditNote.toLocaleString()}
//                     </td>
//                     <td className="py-1.5 text-xs">
//                       <Badge color={statusBadgeColor}>{inv.status}</Badge>
//                     </td>
//                     <td className="py-1.5 text-xs text-slate-700">{inv.dueDate}</td>
//                   </tr>
//                 );
//               })}
//               {invoices.length === 0 && (
//                 <tr>
//                   <td
//                     colSpan={7}
//                     className="py-4 text-center text-xs text-slate-500"
//                   >
//                     No invoices available.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </SectionCard>
//     </div>
//   );
// }